import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Upload, RefreshCw, Download, Calendar, TrendingUp, TrendingDown, X, Users, Search, Camera, Plus, Minus, Settings, Edit2, Eye, FileText, ChevronDown, MessageCircle, Link2, Unlink, CheckSquare, Square, Loader2, CheckCircle2, Trophy, Skull, Dice5, Award } from 'lucide-react';
import { toast } from 'sonner';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { AgenciaBlackjackCell, GanRbkConBj } from '../components/AgenciaBlackjack';
import LastAutomaticImport from '../components/LastAutomaticImport';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AgentesUnited() {
  const userStored = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = userStored.role !== 'worker';

  const [clubs, setClubs] = useState([]);
  const [saldosFin, setSaldosFin] = useState({});
  const [selectedClub, setSelectedClub] = useState(null); // Para drill-down a agencias
  const [selectedAgencia, setSelectedAgencia] = useState(null); // Para drill-down a jugadores
  const [agencias, setAgencias] = useState([]);
  const [jugadores, setJugadores] = useState([]); // Jugadores detallados por fecha
  const [loadingAgencias, setLoadingAgencias] = useState(false);
  const [loadingJugadores, setLoadingJugadores] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // 0-100 para barra de progreso visual
  const [lastUpdateAgentes, setLastUpdateAgentes] = useState(null);
  const [lastUpdateMethodAgentes, setLastUpdateMethodAgentes] = useState(null);
  
  // Estados para filtro de fechas
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [fechasDisponibles, setFechasDisponibles] = useState({ fecha_min: null, fecha_max: null, total_dias: 0 });
  
  // Estado para busqueda de jugador
  const [searchJugadorId, setSearchJugadorId] = useState('');
  
  // Estado para agencias seleccionadas (para sumar)
  const [agenciasSeleccionadas, setAgenciasSeleccionadas] = useState([]);
  const [agenciasExpandidas, setAgenciasExpandidas] = useState([]); // Para expandir/colapsar detalles
  
  // Estado para Rakeback % global predeterminado (50%)
  const [rakebackPorcentaje, setRakebackPorcentaje] = useState(50);
  const [mostrarConfigRakeback, setMostrarConfigRakeback] = useState(false);
  
  // Estado para edicion de rakeback
  const [editandoRakeback, setEditandoRakeback] = useState(null); // ID de agencia siendo editada
  
  // Estado para modal de resumen de ciclo
  const [agenciaResumen, setAgenciaResumen] = useState(null);
  const [jugadoresResumen, setJugadoresResumen] = useState([]);
  const [loadingResumen, setLoadingResumen] = useState(false);
  
  // Estados para configuracion agencia-cliente
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [configAgencia, setConfigAgencia] = useState(null); // Agencia que se esta configurando
  const [carterasConClientes, setCarterasConClientes] = useState([]);
  const [selectedCartera, setSelectedCartera] = useState('');
  const [selectedCliente, setSelectedCliente] = useState('');
  const [agenciaClienteConfigs, setAgenciaClienteConfigs] = useState({}); // Mapa agencia_id -> config
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [enviandoWhatsapp, setEnviandoWhatsapp] = useState(null); // ID de agencia enviando
  const [incluirBlackjack, setIncluirBlackjack] = useState({}); // agencia_id -> bool (guardado en backend)
  
  // === NUEVOS ESTADOS: Modal de seleccion de jugadores ===
  const [showJugadoresSelectModal, setShowJugadoresSelectModal] = useState(false);
  const [jugadoresSelectAgencia, setJugadoresSelectAgencia] = useState(null); // Agencia del modal de seleccion
  const [jugadoresParaSeleccionar, setJugadoresParaSeleccionar] = useState([]); // Lista de jugadores
  const [jugadoresSeleccionados, setJugadoresSeleccionados] = useState({}); // Map jugador_id -> bool
  const [agenciasJugadoresCustom, setAgenciasJugadoresCustom] = useState({}); // Map agencia_id -> {jugador_ids: [], totales: {ganancia, cuota_rake, total}}
  const [loadingJugadoresSelect, setLoadingJugadoresSelect] = useState(false);
  const [descargandoExcel, setDescargandoExcel] = useState(false);
  const [descargandoExcelCierre, setDescargandoExcelCierre] = useState(false);
  const [descargandoExcelCruce, setDescargandoExcelCruce] = useState(false);

  // === ESTADOS: Modal Top 5 Jugadores ===
  const [showTop5Modal, setShowTop5Modal] = useState(false);
  const [top5Data, setTop5Data] = useState(null);
  const [top5Loading, setTop5Loading] = useState(false);
  const [top5Tipo, setTop5Tipo] = useState('AMBOS'); // PPSR | PPST | AMBOS
  const [top5RangoMode, setTop5RangoMode] = useState('semana'); // 'semana' | 'manual'
  const [top5FechaDesde, setTop5FechaDesde] = useState('');
  const [top5FechaHasta, setTop5FechaHasta] = useState('');
  const [top5Tab, setTop5Tab] = useState('ganadores'); // ganadores | perdedores | mesas | mtt

  // Funcion para obtener rakeback de una agencia desde el objeto de la agencia
  const getRakebackAgencia = (agencia) => {
    // Ahora viene directamente del backend
    return agencia?.rakeback_percentage !== undefined 
      ? agencia.rakeback_percentage 
      : rakebackPorcentaje;
  };
  
  // Ref para capturar screenshot
  const screenshotRef = useRef(null);
  
  useEffect(() => {
    loadLastUpdate();
  }, []);
  
  const loadLastUpdate = async () => {
    try {
      const response = await axios.get(`${API}/uploads/last-update`);
      if (response.data && response.data.last_agentes) {
        setLastUpdateAgentes(response.data.last_agentes.timestamp);
        setLastUpdateMethodAgentes(response.data.last_agentes.upload_method_label);
      }
    } catch (error) {
      console.log('No se pudo obtener informacion de ultima actualizacion:', error);
    }
  };
  
  // Funcion para capturar screenshot
  const captureScreenshot = async () => {
    if (!screenshotRef.current) return;
    
    try {
      const canvas = await html2canvas(screenshotRef.current, {
        backgroundColor: '#ffffff',
        scale: 2, // Mayor calidad
        logging: false,
        useCORS: true
      });
      
      // Convertir a imagen y descargar
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `jugadores_${selectedAgencia.agencia_name}_${searchJugadorId || 'todos'}_${new Date().toISOString().split('T')[0]}.png`;
      link.href = image;
      link.click();
      
      toast.success('Screenshot capturado correctamente');
    } catch (error) {
      console.error('Error capturando screenshot:', error);
      toast.error('Error al capturar screenshot');
    }
  };
  
  // Funcion para exportar resumen de ciclo a PDF (optimizado para celular)
    const exportarResumenPDF = async () => {
    if (!agenciaResumen) return;
    
    try {
      toast.info("Generando PDF...");
      
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const TASA_PP_ARS = 300;
      
      // Calcular numero de semana
      const getWeekNumber = (dateStr) => {
        const date = new Date(dateStr);
        const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
        const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
        return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
      };
      const weekNum = getWeekNumber(fechaDesde);
      
      let yPos = 15;
      
      // === HEADER SIN COLOR ===
      // Logo mas grande
      try {
        const logoUrl = "/united_poker_logo.png";
        const logoImg = new Image();
        logoImg.crossOrigin = "anonymous";
        await new Promise((resolve, reject) => {
          logoImg.onload = resolve;
          logoImg.onerror = reject;
          logoImg.src = logoUrl;
        });
        doc.addImage(logoImg, "PNG", 15, yPos, 40, 25);
      } catch (e) {
        doc.setTextColor(30, 64, 175);
        doc.setFontSize(14);
        doc.setFont(undefined, "bold");
        doc.text("UNITED POKER", 15, yPos + 15);
      }
      
      // Titulo
      doc.setTextColor(30, 41, 59);
      doc.setFontSize(20);
      doc.setFont(undefined, "bold");
      doc.text("Resumen de Agencia", 65, yPos + 12);
      
      // Subtitulo con semana
      doc.setFontSize(10);
      doc.setFont(undefined, "normal");
      doc.setTextColor(100, 116, 139);
      doc.text(agenciaResumen.agencia_name + " | Semana " + weekNum + " | " + fechaDesde + " a " + fechaHasta, 65, yPos + 22);
      
      yPos = 55;
      
      // === SECCION: INFORMACION DE LA AGENCIA ===
      doc.setFillColor(248, 250, 252);
      doc.roundedRect(12, yPos, pageWidth - 24, 50, 3, 3, "F");
      
      // Titulo seccion
      doc.setTextColor(30, 41, 59);
      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.text("Informacion de la Agencia", 18, yPos + 12);
      
      // Columna izquierda
      doc.setFontSize(9);
      doc.setFont(undefined, "normal");
      doc.setTextColor(100, 116, 139);
      doc.text("Agencia:", 18, yPos + 24);
      doc.setTextColor(30, 41, 59);
      doc.setFont(undefined, "bold");
      doc.text(agenciaResumen.agencia_name, 18, yPos + 32);
      
      doc.setFont(undefined, "normal");
      doc.setTextColor(100, 116, 139);
      doc.text("Club:", 18, yPos + 40);
      doc.setTextColor(30, 41, 59);
      doc.setFont(undefined, "bold");
      doc.text(selectedClub?.club_name || "N/A", 18, yPos + 48);
      
      // Columna derecha
      doc.setFont(undefined, "normal");
      doc.setTextColor(100, 116, 139);
      doc.text("ID Agencia:", pageWidth / 2 + 10, yPos + 24);
      doc.setTextColor(30, 41, 59);
      doc.setFont(undefined, "bold");
      doc.text(agenciaResumen.agencia_id, pageWidth / 2 + 10, yPos + 32);
      
      doc.setFont(undefined, "normal");
      doc.setTextColor(100, 116, 139);
      doc.text("Semana:", pageWidth / 2 + 10, yPos + 40);
      doc.setTextColor(30, 41, 59);
      doc.setFont(undefined, "bold");
      doc.text("Semana " + weekNum + " (" + fechaDesde + " a " + fechaHasta + ")", pageWidth / 2 + 10, yPos + 48);
      
      yPos += 60;
      
      // === SECCION: TOTALES DEL PERIODO ===
      doc.setFillColor(248, 250, 252);
      doc.roundedRect(12, yPos, pageWidth - 24, 55, 3, 3, "F");
      
      doc.setTextColor(30, 41, 59);
      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.text("Totales del Periodo", 18, yPos + 12);
      
      // Calculos
      const rbk = getRakebackAgencia(agenciaResumen);
      const spin3pct = parseFloat(agenciaResumen.spin_3pct) || 0;
      const rakebackMonto = agenciaResumen.cuota_rake * (rbk / 100);
      const subtotal = agenciaResumen.ganancia + agenciaResumen.cuota_rake;
      const totalFinal = agenciaResumen.ganancia + rakebackMonto + spin3pct;
      
      // Cajas de valores
      const boxWidth = (pageWidth - 24 - 20) / 5;
      const boxY = yPos + 18;
      const boxHeight = 28;
      
      const formatVal = (n) => n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      
      const drawValueBox = (x, label, value, isPercent = false) => {
        doc.setFillColor(255, 255, 255);
        doc.roundedRect(x, boxY, boxWidth - 4, boxHeight, 2, 2, "F");
        
        doc.setTextColor(100, 116, 139);
        doc.setFontSize(8);
        doc.setFont(undefined, "normal");
        doc.text(label, x + (boxWidth - 4) / 2, boxY + 8, { align: "center" });
        
        doc.setFontSize(11);
        doc.setFont(undefined, "bold");
        
        if (isPercent) {
          doc.setTextColor(14, 165, 233);
          doc.text(value + "%", x + (boxWidth - 4) / 2, boxY + 20, { align: "center" });
        } else {
          const numVal = parseFloat(value.replace(/\./g, "").replace(",", "."));
          if (numVal < 0) {
            doc.setTextColor(239, 68, 68);
          } else {
            doc.setTextColor(30, 41, 59);
          }
          doc.text(value, x + (boxWidth - 4) / 2, boxY + 20, { align: "center" });
        }
      };
      
      drawValueBox(14, "Ganancia", formatVal(agenciaResumen.ganancia));
      drawValueBox(14 + boxWidth, "Cuota/Rake", formatVal(agenciaResumen.cuota_rake));
      drawValueBox(14 + boxWidth * 2, "Subtotal", formatVal(subtotal));
      drawValueBox(14 + boxWidth * 3, "Rakeback", String(rbk), true);
      drawValueBox(14 + boxWidth * 4, "GAN + RBK", formatVal(totalFinal));
      
      yPos += 65;
      
      // === SECCION: DETALLE FINANCIERO (solo PP) ===
      doc.setFillColor(248, 250, 252);
      doc.roundedRect(12, yPos, pageWidth - 24, 85, 3, 3, "F");
      
      doc.setTextColor(30, 41, 59);
      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.text("Detalle Financiero", 18, yPos + 12);
      
      // Encabezados
      const col1 = 18;
      const col2 = pageWidth - 30;
      
      doc.setFontSize(8);
      doc.setTextColor(100, 116, 139);
      doc.setFont(undefined, "bold");
      doc.text("CONCEPTO", col1, yPos + 24);
      doc.text("PP", col2, yPos + 24, { align: "right" });
      
      doc.setDrawColor(226, 232, 240);
      doc.line(col1, yPos + 27, pageWidth - 18, yPos + 27);
      
      // Filas
      const drawRow = (y, label, ppValue) => {
        doc.setFontSize(10);
        doc.setFont(undefined, "normal");
        doc.setTextColor(71, 85, 105);
        doc.text(label, col1, y);
        
        doc.setFont(undefined, "bold");
        if (ppValue < 0) {
          doc.setTextColor(239, 68, 68);
        } else {
          doc.setTextColor(30, 41, 59);
        }
        doc.text(formatVal(ppValue), col2, y, { align: "right" });
      };
      
      drawRow(yPos + 36, "Ganancia", agenciaResumen.ganancia);
      drawRow(yPos + 46, "Cuota / Rake", agenciaResumen.cuota_rake);
      drawRow(yPos + 56, "Rakeback (" + rbk + "%)", rakebackMonto);
      drawRow(yPos + 66, "Spin 3%", spin3pct);
      
      // Linea antes del total
      doc.setDrawColor(180, 180, 180);
      doc.line(col1, yPos + 70, pageWidth - 18, yPos + 70);
      
      // TOTAL FINAL
      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.setTextColor(30, 41, 59);
      doc.text("TOTAL FINAL", col1, yPos + 80);
      
      if (totalFinal >= 0) {
        doc.setTextColor(34, 197, 94);
      } else {
        doc.setTextColor(239, 68, 68);
      }
      doc.text(formatVal(totalFinal), col2, yPos + 80, { align: "right" });
      
      yPos += 95;
      
      // === TOTAL CONVERSION (ARS sin simbolo) ===
      doc.setFillColor(241, 245, 249);
      doc.roundedRect(12, yPos, pageWidth - 24, 18, 3, 3, "F");
      
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.setTextColor(100, 116, 139);
      doc.text("Total Conversion", 18, yPos + 12);
      
      const totalARS = totalFinal * TASA_PP_ARS;
      if (totalARS >= 0) {
        doc.setTextColor(34, 197, 94);
      } else {
        doc.setTextColor(239, 68, 68);
      }
      doc.text(formatVal(totalARS), pageWidth - 30, yPos + 12, { align: "right" });
      
      yPos += 28;
      
      // === INFO ADICIONAL ===
      doc.setTextColor(148, 163, 184);
      doc.setFontSize(8);
      doc.setFont(undefined, "normal");
      doc.text("Jugadores en periodo: " + jugadoresResumen.length, 18, yPos);
      doc.text("Tasa PP/ARS: " + TASA_PP_ARS, pageWidth - 18, yPos, { align: "right" });
      
      // === FOOTER ===
      doc.setDrawColor(226, 232, 240);
      doc.line(12, pageHeight - 18, pageWidth - 12, pageHeight - 18);
      
      doc.setTextColor(180, 180, 180);
      doc.setFontSize(7);
      doc.text("United Poker - Sistema de Gestion", pageWidth / 2, pageHeight - 10, { align: "center" });
      
      // Guardar
      const fileName = "Agencia_" + agenciaResumen.agencia_name.replace(/\s+/g, "_") + "_Semana" + weekNum + ".pdf";
      doc.save(fileName);
      
      toast.success("PDF generado");
    } catch (error) {
      console.error("Error generando PDF:", error);
      toast.error("Error: " + error.message);
    }
  };

  
  // Toggle seleccion de agencia para suma
  const toggleAgenciaSeleccion = (agencia) => {
    setAgenciasSeleccionadas(prev => {
      const existe = prev.find(a => a.agencia_id === agencia.agencia_id);
      if (existe) {
        // Quitar de la seleccion
        return prev.filter(a => a.agencia_id !== agencia.agencia_id);
      } else {
        // Agregar a la seleccion
        return [...prev, agencia];
      }
    });
  };

  // Guardar rakeback al backend
  const saveRakebackToBackend = async (agenciaId, percentage) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API}/poker/agencias/${agenciaId}/rakeback`,
        { rakeback_percentage: percentage },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Recargar agencias para obtener el valor actualizado
      await loadAgencias();
      
      toast.success(`Rakeback configurado a ${percentage}%`);
    } catch (error) {
      console.error('Error guardando rakeback:', error);
      toast.error('Error al guardar rakeback');
    }
  };

  
  // Calcular totales de agencias seleccionadas
  const calcularTotalesSeleccionadas = () => {
    const totales = agenciasSeleccionadas.reduce((acc, agencia) => {
      const rbk = getRakebackAgencia(agencia);
      // Usar totales custom si existen (cuando se deseleccionaron jugadores)
      const custom = agenciasJugadoresCustom[agencia.agencia_id];
      const gan = custom ? custom.totales.ganancia : agencia.ganancia;
      const cr = custom ? custom.totales.cuota_rake : agencia.cuota_rake;
      const tot = custom ? custom.totales.total : agencia.total;
      return {
        ganancia: acc.ganancia + gan,
        cuota_rake: acc.cuota_rake + cr,
        total: acc.total + tot,
        ganRbk: acc.ganRbk + (gan + (cr * (rbk / 100)))
      };
    }, { ganancia: 0, cuota_rake: 0, total: 0, ganRbk: 0 });
    
    return totales;
  };

  // Toggle para expandir/colapsar detalle de agencia
  const toggleExpandAgencia = (agenciaId) => {
    setAgenciasExpandidas(prev => 
      prev.includes(agenciaId) 
        ? prev.filter(id => id !== agenciaId)
        : [...prev, agenciaId]
    );
  };

  // Exportar PDF de cierre de ciclo
  const exportarPDFCierreCiclo = () => {
    try {
      const doc = new jsPDF();
      const totales = calcularTotalesSeleccionadas();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      
      // ============ HEADER MODERNO ============
      doc.setFillColor(16, 185, 129);
      doc.rect(0, 0, pageWidth, 35, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(22);
      doc.text('CIERRE DE CICLO SEMANAL', pageWidth / 2, 15, { align: 'center' });
      
      doc.setFontSize(10);
      doc.text(`Periodo: ${fechaDesde} al ${fechaHasta}`, pageWidth / 2, 23, { align: 'center' });
      doc.text(`Generado: ${new Date().toLocaleDateString('es-AR')} - ${new Date().toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}`, pageWidth / 2, 29, { align: 'center' });
      
      doc.setTextColor(0, 0, 0);
      
      const startY = 45;
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(15, startY, 60, 10, 2, 2, 'F');
      doc.setFontSize(9);
      doc.text(`${agenciasSeleccionadas.length} Agencias`, 17, startY + 6.5);
      
      doc.setFontSize(14);
      doc.text('Resumen Consolidado', 20, startY + 20);
      
      const cardY = startY + 28;
      const rakebackTotal = totales.ganRbk - totales.ganancia;
      
      doc.setFillColor(249, 250, 251);
      doc.roundedRect(15, cardY, pageWidth - 30, 35, 3, 3, 'F');
      
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);
      
      doc.text('Ganancia Total', 20, cardY + 8);
      doc.setFontSize(11);
      doc.setTextColor(totales.ganancia < 0 ? 220 : 0, totales.ganancia < 0 ? 38 : 0, totales.ganancia < 0 ? 38 : 0);
      doc.text(String(formatNumber(totales.ganancia)), 20, cardY + 15);
      
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);
      doc.text('Cuota/Rake Total', 70, cardY + 8);
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);
      doc.text(String(formatNumber(totales.cuota_rake)), 70, cardY + 15);
      
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);
      doc.text('Rakeback Aplicado', 125, cardY + 8);
      doc.setFontSize(11);
      doc.setTextColor(34, 139, 230);
      doc.text(String(formatNumber(rakebackTotal)), 125, cardY + 15);
      
      doc.setFillColor(34, 197, 94);
      doc.roundedRect(18, cardY + 22, pageWidth - 36, 10, 2, 2, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(10);
      doc.text('GANANCIA + RAKEBACK:', 23, cardY + 28.5);
      doc.setFontSize(12);
      doc.text(String(formatNumber(totales.ganRbk)), pageWidth - 23, cardY + 28.5, { align: 'right' });
      
      doc.setTextColor(0, 0, 0);
      
      doc.setFontSize(12);
      doc.text('Detalle por Agencia', 20, cardY + 43);
      
      const tableData = agenciasSeleccionadas.map(agencia => {
        const rbk = getRakebackAgencia(agencia);
        const custom = agenciasJugadoresCustom[agencia.agencia_id];
        const gan = custom ? custom.totales.ganancia : agencia.ganancia;
        const cr = custom ? custom.totales.cuota_rake : agencia.cuota_rake;
        const tot = custom ? custom.totales.total : agencia.total;
        const rakebackMonto = cr * (rbk / 100);
        const ganRbk = gan + rakebackMonto;
        
        return [
          String(agencia.agencia_name || ''),
          String(formatNumber(gan)),
          String(formatNumber(cr)),
          String(formatNumber(tot)),
          `${rbk}%`,
          String(formatNumber(rakebackMonto)),
          String(formatNumber(ganRbk))
        ];
      });
      
      autoTable(doc, {
        startY: cardY + 50,
        head: [['Agencia', 'Ganancia', 'Cuota/Rake', 'Subtotal', 'RBK%', 'RBK Monto', 'GAN+RBK']],
        body: tableData,
        theme: 'striped',
        styles: { 
          fontSize: 8,
          cellPadding: 3,
          lineColor: [220, 220, 220],
          lineWidth: 0.1
        },
        headStyles: { 
          fillColor: [16, 185, 129],
          textColor: [255, 255, 255],
          fontSize: 9,
          fontStyle: 'bold',
          halign: 'center'
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        columnStyles: {
          0: { cellWidth: 45, fontStyle: 'bold' },
          1: { halign: 'right', cellWidth: 25 },
          2: { halign: 'right', cellWidth: 25 },
          3: { halign: 'right', cellWidth: 25 },
          4: { halign: 'center', cellWidth: 15, fillColor: [240, 249, 255] },
          5: { halign: 'right', cellWidth: 25, textColor: [34, 139, 230] },
          6: { halign: 'right', cellWidth: 25, fontStyle: 'bold' }
        }
      });
      
      const footerY = pageHeight - 15;
      
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(20, footerY - 5, pageWidth - 20, footerY - 5);
      
      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);
      doc.text('EvoGameTech', pageWidth / 2, footerY, { align: 'center' });
      doc.setFontSize(7);
      doc.text('https://evogametech.com', pageWidth / 2, footerY + 4, { align: 'center' });
      
      doc.text(`Pagina 1 de 1`, pageWidth - 20, footerY, { align: 'right' });
      
      const filename = `Cierre_Ciclo_${fechaDesde.replace(/\//g, '-')}_${fechaHasta.replace(/\//g, '-')}.pdf`;
      doc.save(filename);
      
      toast.success('PDF generado exitosamente');
    } catch (error) {
      console.error('Error generando PDF:', error);
      toast.error(`Error al generar PDF: ${error.message}`);
    }
  };


  // Cargar rango de fechas disponibles
  const loadFechasDisponibles = async () => {
    try {
      const response = await axios.get(`${API}/poker/fechas-disponibles`);
      setFechasDisponibles(response.data);
    } catch (error) {
      console.error('Error cargando fechas disponibles:', error);
    }
  };

  // Cargar clubs con filtro de fechas
  const loadClubs = async () => {
    if (!fechaDesde || !fechaHasta) {
      setClubs([]);
      return;
    }
    
    setLoading(true);
    try {
      const response = await axios.get(`${API}/poker/clubs?fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`);
      setClubs(response.data);
      loadSaldosFinancieros();   // acá ya está seteado el header de auth (al montar da 403)
    } catch (error) {
      console.error('Error cargando clubs:', error);
      toast.error('Error al cargar clubs');
    } finally {
      setLoading(false);
    }
  };

  // Saldo financiero del CRM por club_id: referencia de resultados vs estado de cuenta
  const loadSaldosFinancieros = async () => {
    try {
      const response = await axios.get(`${API}/poker/clubs/saldos-financieros`);
      setSaldosFin(response.data || {});
    } catch (error) {
      console.error('Error cargando saldos financieros:', error);
    }
  };

  // Cargar datos al montar
  useEffect(() => {
    loadFechasDisponibles();
  }, []);

  // Cargar clubs cuando cambia el filtro de fechas
  useEffect(() => {
    if (fechaDesde && fechaHasta) {
      loadClubs();
    }
  }, [fechaDesde, fechaHasta]);

  // ==================== FUNCIONES CONFIGURACION AGENCIA-CLIENTE ====================
  
  // Cargar carteras con clientes para el selector
  const loadCarterasConClientes = async () => {
    try {
      const response = await axios.get(`${API}/carteras-con-clientes`);
      setCarterasConClientes(response.data);
    } catch (error) {
      console.error('Error cargando carteras:', error);
      toast.error('Error al cargar carteras');
    }
  };
  
  // Cargar configuraciones de todas las agencias mostradas
  const loadAgenciaClienteConfigs = async (agenciaIds) => {
    if (!agenciaIds || agenciaIds.length === 0) return;
    
    try {
      const idsParam = agenciaIds.join(',');
      const response = await axios.get(`${API}/poker/agencia-cliente-configs-bulk?agencia_ids=${idsParam}`);
      setAgenciaClienteConfigs(response.data);
    } catch (error) {
      console.error('Error cargando configs:', error);
    }
  };
  
  // Abrir modal de configuracion
  const openConfigModal = async (agencia) => {
    setConfigAgencia(agencia);
    setShowConfigModal(true);
    setLoadingConfig(true);
    
    if (carterasConClientes.length === 0) {
      await loadCarterasConClientes();
    }
    
    try {
      const response = await axios.get(`${API}/poker/agencia-cliente-config/${agencia.agencia_id}`);
      if (response.data) {
        setSelectedCartera(response.data.cartera_id || '');
        setSelectedCliente(response.data.cliente_id || '');
      } else {
        setSelectedCartera('');
        setSelectedCliente('');
      }
    } catch (error) {
      setSelectedCartera('');
      setSelectedCliente('');
    }
    
    setLoadingConfig(false);
  };
  
  // Guardar configuracion agencia-cliente
  const saveAgenciaClienteConfig = async () => {
    if (!selectedCliente || !configAgencia) {
      toast.error('Selecciona un cliente');
      return;
    }
    
    setLoadingConfig(true);
    try {
      const response = await axios.post(`${API}/poker/agencia-cliente-config`, {
        agencia_id: configAgencia.agencia_id,
        agencia_name: configAgencia.agencia_name,
        club_id: configAgencia.club_id,
        cliente_id: selectedCliente
      });
      
      toast.success(response.data.message);
      
      setAgenciaClienteConfigs(prev => ({
        ...prev,
        [configAgencia.agencia_id]: {
          ...response.data,
          cliente_id: selectedCliente,
          has_whatsapp: response.data.has_whatsapp
        }
      }));
      
      setShowConfigModal(false);
    } catch (error) {
      console.error('Error guardando config:', error);
      toast.error(error.response?.data?.detail || 'Error al guardar configuracion');
    }
    setLoadingConfig(false);
  };
  
  // Eliminar configuracion agencia-cliente
  const deleteAgenciaClienteConfig = async () => {
    if (!configAgencia) return;
    
    setLoadingConfig(true);
    try {
      await axios.delete(`${API}/poker/agencia-cliente-config/${configAgencia.agencia_id}`);
      toast.success('Configuracion eliminada');
      
      setAgenciaClienteConfigs(prev => {
        const newConfigs = { ...prev };
        delete newConfigs[configAgencia.agencia_id];
        return newConfigs;
      });
      
      setShowConfigModal(false);
    } catch (error) {
      console.error('Error eliminando config:', error);
      toast.error('Error al eliminar configuracion');
    }
    setLoadingConfig(false);
  };
  
  // Enviar cierre por WhatsApp
  const enviarCierreWhatsapp = async (agencia) => {
    const config = agenciaClienteConfigs[agencia.agencia_id];
    
    if (!config) {
      toast.error('Configura primero el cliente para esta agencia');
      return;
    }
    
    if (!config.has_whatsapp) {
      toast.error('El cliente no tiene WhatsApp configurado');
      return;
    }

    const incluirBj = !!incluirBlackjack[agencia.agencia_id];
    if (incluirBj && !(parseFloat(agencia.blackjack_porcentaje) > 0)) {
      toast.error('Esta agencia tiene 0% de blackjack: cargá el % antes de incluirlo');
      return;
    }
    
    setEnviandoWhatsapp(agencia.agencia_id);
    
    try {
      const rbk = getRakebackAgencia(agencia);
      const spin3pct = parseFloat(agencia.spin_3pct) || 0;
      const rakebackMonto = agencia.cuota_rake * (rbk / 100);
      const totalFinal = agencia.ganancia + rakebackMonto + spin3pct
        + (incluirBj ? (parseFloat(agencia.blackjack_monto) || 0) : 0);
      
      const response = await axios.post(`${API}/poker/agencias/enviar-cierre-consolidado`, {
        agencia_id: agencia.agencia_id,
        agencia_name: agencia.agencia_name,
        club_id: agencia.club_id,
        club_name: selectedClub?.club_name || '',
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        ganancia: agencia.ganancia,
        cuota_rake: agencia.cuota_rake,
        rakeback_pct: rbk,
        spin_3pct: spin3pct,
        incluir_blackjack: incluirBj,
        total_final: totalFinal,
        jugadores_count: jugadoresResumen.length || 0
      });
      
      toast.success(response.data.message);
    } catch (error) {
      console.error('Error enviando WhatsApp:', error);
      toast.error(error.response?.data?.detail || 'Error al enviar cierre');
    }
    
    setEnviandoWhatsapp(null);
  };
  
  // ==================== FIN FUNCIONES CONFIGURACION ====================

  // ==================== NUEVO: FUNCIONES MODAL SELECCION JUGADORES ====================
  
  // Abrir modal de seleccion de jugadores de una agencia
  const abrirModalSeleccionJugadores = async (agencia) => {
    setJugadoresSelectAgencia(agencia);
    setShowJugadoresSelectModal(true);
    setLoadingJugadoresSelect(true);
    setJugadoresSeleccionados({});
    
    try {
      const response = await axios.get(`${API}/poker/agencias/${agencia.agencia_id}/jugadores-detallado?club_id=${selectedClub.club_id}&fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`);
      setJugadoresParaSeleccionar(response.data);
      
      // Agrupar por jugador_id para obtener jugadores unicos
      const uniqueIds = {};
      response.data.forEach(j => { uniqueIds[j.jugador_id] = true; });
      // Seleccionar todos por defecto
      setJugadoresSeleccionados(uniqueIds);
    } catch (error) {
      console.error('Error cargando jugadores:', error);
      toast.error('Error al cargar jugadores');
      setJugadoresParaSeleccionar([]);
    } finally {
      setLoadingJugadoresSelect(false);
    }
  };
  
  // Toggle seleccion de un jugador individual
  const toggleJugadorSeleccion = (jugadorId) => {
    setJugadoresSeleccionados(prev => {
      const next = { ...prev };
      if (next[jugadorId]) {
        delete next[jugadorId];
      } else {
        next[jugadorId] = true;
      }
      return next;
    });
  };
  
  // Seleccionar/Deseleccionar todos los jugadores
  const toggleTodosJugadores = () => {
    const uniqueIds = {};
    jugadoresParaSeleccionar.forEach(j => { uniqueIds[j.jugador_id] = true; });
    
    const todosSeleccionados = Object.keys(uniqueIds).every(id => jugadoresSeleccionados[id]);
    
    if (todosSeleccionados) {
      setJugadoresSeleccionados({});
    } else {
      setJugadoresSeleccionados(uniqueIds);
    }
  };
  
  // Obtener jugadores unicos agrupados para mostrar en el modal
  const getJugadoresUnicos = () => {
    const mapa = {};
    jugadoresParaSeleccionar.forEach(j => {
      if (!mapa[j.jugador_id]) {
        mapa[j.jugador_id] = {
          jugador_id: j.jugador_id,
          jugador_name: j.jugador_name,
          ganancia: 0,
          cuota_rake: 0,
          total: 0,
          dias: 0
        };
      }
      mapa[j.jugador_id].ganancia += j.ganancia;
      mapa[j.jugador_id].cuota_rake += j.cuota_rake;
      mapa[j.jugador_id].total += j.total;
      mapa[j.jugador_id].dias += 1;
    });
    return Object.values(mapa);
  };
  
  // Aplicar seleccion de jugadores y actualizar totales de agencia
  const aplicarSeleccionJugadores = () => {
    if (!jugadoresSelectAgencia) return;
    
    const selectedJugs = getJugadoresUnicos().filter(j => jugadoresSeleccionados[j.jugador_id]);
    const totales = {
      ganancia: selectedJugs.reduce((s, j) => s + j.ganancia, 0),
      cuota_rake: selectedJugs.reduce((s, j) => s + j.cuota_rake, 0),
      total: selectedJugs.reduce((s, j) => s + j.total, 0)
    };
    
    const selectedIds = Object.keys(jugadoresSeleccionados);
    
    setAgenciasJugadoresCustom(prev => ({
      ...prev,
      [jugadoresSelectAgencia.agencia_id]: {
        jugador_ids: selectedIds,
        totales: totales
      }
    }));
    
    // Si la agencia ya esta seleccionada en el cuadro verde, actualizar
    setAgenciasSeleccionadas(prev => prev.map(a => {
      if (a.agencia_id === jugadoresSelectAgencia.agencia_id) {
        return { ...a, _customTotales: totales };
      }
      return a;
    }));
    
    toast.success(`Seleccion aplicada: ${selectedIds.length} jugadores (Ganancia: ${formatNumber(totales.ganancia)}, Total: ${formatNumber(totales.total)})`);
  };

  // Descargar Excel profesional desde el backend
  const descargarExcelJugadores = async () => {
    const selectedIds = Object.keys(jugadoresSeleccionados);
    if (selectedIds.length === 0) {
      toast.error('Selecciona al menos un jugador');
      return;
    }
    
    setDescargandoExcel(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API}/poker/agencias/excel-jugadores`,
        {
          agencia_id: jugadoresSelectAgencia.agencia_id,
          agencia_name: jugadoresSelectAgencia.agencia_name,
          club_id: selectedClub.club_id,
          club_name: selectedClub.club_name,
          fecha_desde: fechaDesde,
          fecha_hasta: fechaHasta,
          jugador_ids: selectedIds,
          rakeback_percentage: getRakebackAgencia(jugadoresSelectAgencia)
        },
        { 
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        }
      );
      
      // Descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = `Agencia_${jugadoresSelectAgencia.agencia_name.replace(/\s+/g, '_')}_${fechaDesde}_${fechaHasta}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success('Excel descargado correctamente');
    } catch (error) {
      console.error('Error descargando Excel:', error);
      toast.error('Error al generar el Excel');
    } finally {
      setDescargandoExcel(false);
    }
  };
  
  // ==================== FIN FUNCIONES MODAL SELECCION JUGADORES ====================

  // Descargar Excel cruce de jugadores por agencia
  const descargarExcelCruce = async (agencia) => {
    setDescargandoExcelCruce(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API}/poker/agencias/excel-cruce-jugadores`,
        {
          agencia_id: agencia.agencia_id,
          agencia_name: agencia.agencia_name,
          club_id: selectedClub.club_id,
          club_name: selectedClub.club_name,
          fecha_desde: fechaDesde,
          fecha_hasta: fechaHasta
        },
        { 
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        }
      );
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = `Cruce_${agencia.agencia_name.replace(/\s+/g, '_')}_${fechaDesde}_${fechaHasta}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success('Excel de cruce descargado');
    } catch (error) {
      console.error('Error descargando Excel cruce:', error);
      toast.error('Error al generar el Excel de cruce');
    } finally {
      setDescargandoExcelCruce(false);
    }
  };

  // === Top 5 Jugadores: helpers ===
  const getRangoEstaSemana = () => {
    // Lunes a Domingo de la semana actual
    const hoy = new Date();
    const dia = hoy.getDay(); // 0=Dom, 1=Lun, ..., 6=Sab
    const offsetLunes = dia === 0 ? -6 : 1 - dia; // mover a lunes
    const lunes = new Date(hoy);
    lunes.setDate(hoy.getDate() + offsetLunes);
    const domingo = new Date(lunes);
    domingo.setDate(lunes.getDate() + 6);
    const fmt = (d) => d.toISOString().slice(0, 10);
    return { desde: fmt(lunes), hasta: fmt(domingo) };
  };

  const abrirTop5Modal = () => {
    // Inicializa con esta semana por defecto
    const { desde, hasta } = getRangoEstaSemana();
    setTop5FechaDesde(desde);
    setTop5FechaHasta(hasta);
    setTop5RangoMode('semana');
    setTop5Tipo('AMBOS');
    setTop5Tab('ganadores');
    setTop5Data(null);
    setShowTop5Modal(true);
    // Cargar automaticamente con esta semana + AMBOS
    cargarTop5(desde, hasta, 'AMBOS');
  };

  const cargarTop5 = async (desde, hasta, tipo) => {
    if (!selectedAgencia) return;
    if (!desde || !hasta) {
      toast.error('Selecciona un rango de fechas valido');
      return;
    }
    setTop5Loading(true);
    try {
      const params = new URLSearchParams({
        fecha_desde: desde,
        fecha_hasta: hasta,
        tipo: tipo || 'AMBOS',
        union_id: '2006'
      });
      if (selectedClub?.club_id) params.append('club_id', selectedClub.club_id);
      const res = await axios.get(
        `${API}/poker/agencias/${selectedAgencia.agencia_id}/top-jugadores?${params.toString()}`
      );
      setTop5Data(res.data);
    } catch (error) {
      console.error('Error cargando Top 5:', error);
      toast.error(error.response?.data?.detail || 'Error al cargar Top 5');
    } finally {
      setTop5Loading(false);
    }
  };

  const aplicarRangoEstaSemana = () => {
    const { desde, hasta } = getRangoEstaSemana();
    setTop5FechaDesde(desde);
    setTop5FechaHasta(hasta);
    setTop5RangoMode('semana');
    cargarTop5(desde, hasta, top5Tipo);
  };

  const aplicarRangoManual = () => {
    setTop5RangoMode('manual');
    cargarTop5(top5FechaDesde, top5FechaHasta, top5Tipo);
  };

  const cambiarTipoTop5 = (nuevoTipo) => {
    setTop5Tipo(nuevoTipo);
    // Auto-corregir tab si se queda en uno no disponible
    if (nuevoTipo === 'PPSR' && top5Tab === 'mtt') setTop5Tab('ganadores');
    if (nuevoTipo === 'PPST' && top5Tab === 'mesas') setTop5Tab('ganadores');
    cargarTop5(top5FechaDesde, top5FechaHasta, nuevoTipo);
  };

  // Descargar Excel del cierre ciclo (agencias acumuladas)
  const descargarExcelCierreCiclo = async () => {
    if (agenciasSeleccionadas.length === 0) {
      toast.error('No hay agencias seleccionadas');
      return;
    }
    
    setDescargandoExcelCierre(true);
    try {
      const token = localStorage.getItem('token');
      const agenciasData = agenciasSeleccionadas.map(ag => {
        const custom = agenciasJugadoresCustom[ag.agencia_id];
        return {
          agencia_id: ag.agencia_id,
          agencia_name: ag.agencia_name,
          ganancia: custom ? custom.totales.ganancia : ag.ganancia,
          cuota_rake: custom ? custom.totales.cuota_rake : ag.cuota_rake,
          total: custom ? custom.totales.total : ag.total,
          rakeback_percentage: getRakebackAgencia(ag),
          jugador_ids: custom ? custom.jugador_ids : null
        };
      });
      
      const response = await axios.post(
        `${API}/poker/agencias/excel-cierre-ciclo`,
        {
          club_name: selectedClub?.club_name || 'Club',
          club_id: selectedClub?.club_id || '',
          fecha_desde: fechaDesde,
          fecha_hasta: fechaHasta,
          agencias: agenciasData,
          rakeback_default: rakebackPorcentaje
        },
        { 
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        }
      );
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = `Cierre_Ciclo_${fechaDesde}_${fechaHasta}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success('Excel de cierre descargado');
    } catch (error) {
      console.error('Error descargando Excel cierre:', error);
      toast.error('Error al generar el Excel');
    } finally {
      setDescargandoExcelCierre(false);
    }
  };

  // Cargar agencias de un club
  const loadAgencias = async (clubId = selectedClub?.club_id) => {
    if (!clubId || !fechaDesde || !fechaHasta) {
      return;
    }
    
    setLoadingAgencias(true);
    try {
      const response = await axios.get(`${API}/poker/clubs/${clubId}/agencias?fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`);
      setAgencias(response.data);
      // El check "incluir blackjack" queda guardado por agencia en el backend
      setIncluirBlackjack(Object.fromEntries(response.data.map(a => [a.agencia_id, !!a.blackjack_incluir])));
      toast.success(`${response.data.length} agencias cargadas`);
      
      if (response.data.length > 0) {
        const agenciaIds = response.data.map(a => a.agencia_id);
        await loadAgenciaClienteConfigs(agenciaIds);
      }
    } catch (error) {
      console.error('Error cargando agencias:', error);
      toast.error('Error al cargar agencias');
    } finally {
      setLoadingAgencias(false);
    }
  };


  // Manejar importacion de archivo
  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;

    setUploading(true);
    setUploadProgress(1);
    const loadingToast = toast.loading(
      files.length === 1 ? `Procesando "${files[0].name}"...` : `Procesando ${files.length} archivos...`,
      { description: 'Leyendo Excel y guardando en base de datos.' }
    );

    const resumen = [];
    let fallidos = 0;

    try {
      // Secuencial: un archivo por vez (cada uno conserva su propia fecha)
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        toast.loading(`Procesando ${i + 1}/${files.length}: "${file.name}"`, {
          id: loadingToast,
          description: 'No cierres la pestana hasta que termine.',
        });

        const formData = new FormData();
        formData.append('file', file);

        try {
          const response = await axios.post(`${API}/poker/import`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 300000,
            onUploadProgress: (e) => {
              if (e.total) {
                const base = (i / files.length) * 100;
                const share = (1 / files.length) * 100;
                setUploadProgress((prev) => Math.max(prev, base + (e.loaded / e.total) * share * 0.4));
              }
            },
          });
          const r = response.data || {};
          resumen.push(`${r.fecha || file.name}: ${r.clubs_importados || 0} clubs · ${r.agencias_importadas || 0} agencias · ${r.jugadores_importados || 0} jugadores`);
        } catch (err) {
          fallidos++;
          console.error(`Error importando ${file.name}:`, err);
          resumen.push(`ERROR ${file.name}: ${err.response?.data?.detail || err.message || 'desconocido'}`);
        }

        setUploadProgress(Math.round(((i + 1) / files.length) * 100));
      }

      if (fallidos === 0) {
        toast.success(
          files.length === 1 ? '✅ Excel importado correctamente' : `✅ ${files.length} archivos importados`,
          { id: loadingToast, description: resumen.join('\n'), duration: 10000 }
        );
      } else {
        toast.error(`⚠️ ${files.length - fallidos} de ${files.length} importados (${fallidos} con error)`, {
          id: loadingToast,
          description: resumen.join('\n'),
          duration: 15000,
        });
      }

      await loadFechasDisponibles();
      await loadClubs();
    } finally {
      setTimeout(() => {
        setUploading(false);
        setUploadProgress(0);
      }, 600);
      event.target.value = '';
    }
  };

  // Formatear numero con separadores de miles
  const formatNumber = (num) => {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  // Calcular totales
  const totales = clubs.reduce((acc, club) => ({
    ganancia: acc.ganancia + club.ganancia,
    cuota_rake: acc.cuota_rake + club.cuota_rake,
    total: acc.total + club.total
  }), { ganancia: 0, cuota_rake: 0, total: 0 });

  const totalSaldoFin = clubs.reduce(
    (acc, club) => acc + (saldosFin[String(club.club_id)]?.saldo ?? 0), 0);

  return (
    <div className="p-4 lg:p-6 space-y-4">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white flex items-center gap-2">
            Agentes United
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Clubs, agencias y resultados de la unión
          </p>
        </div>

        {/* Botones de accion */}
        <div className="flex flex-wrap gap-2 text-sm font-medium">
          {isAdmin && (<button
            onClick={() => loadClubs()}
            disabled={loading || !fechaDesde || !fechaHasta}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors disabled:opacity-50"
            data-testid="btn-actualizar-clubs"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            Actualizar
          </button>)}

          {isAdmin && (<label
              className={`relative overflow-hidden flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-white ${uploading ? 'bg-orange-300 cursor-wait pointer-events-none' : 'bg-orange-600 hover:bg-orange-700 cursor-pointer'}`}
              data-testid="btn-import-excel"
              title={uploading ? `Procesando Excel: ${Math.round(uploadProgress)}%` : 'Importar Excel de Agentes United'}
            >
              {/* Barra de progreso: relleno naranja oscuro de izquierda a derecha */}
              {uploading && (
                <span
                  aria-hidden
                  className="absolute inset-y-0 left-0 bg-orange-700 transition-all duration-500 ease-out"
                  style={{ width: `${uploadProgress}%` }}
                />
              )}
              <span className="relative z-10 flex items-center gap-2">
                {uploading ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <Upload className="w-4 h-4" />
                )}
                {uploading ? `Importando ${Math.round(uploadProgress)}%` : 'Importar Excel'}
              </span>
              <input
                type="file"
                accept=".xlsx,.xls"
                multiple
                onChange={handleFileUpload}
                disabled={uploading}
                className="hidden"
                data-testid="input-excel-file"
              />
            </label>)}
        </div>
      </div>

      {/* Leyenda de ultima actualizacion */}
      <div className="bg-white dark:bg-gray-800 rounded-xl px-4 py-3 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-2 mb-2">
          <RefreshCw className="w-4 h-4 text-orange-600" />
          <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Última actualización</h3>
        </div>
        <LastAutomaticImport />
        <div className="text-sm space-y-1">
          <div className="flex items-center gap-2">
            <span className="text-gray-600 dark:text-gray-300 font-medium">Agentes United:</span>
            {lastUpdateAgentes ? (
              <span className="text-gray-700 dark:text-gray-300">
                {new Date(lastUpdateAgentes).toLocaleString('es-AR', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                })}
              </span>
            ) : (
              <span className="text-gray-500 italic">Sin importaciones</span>
            )}
          </div>
          {lastUpdateMethodAgentes && (
            <div className="ml-6 text-xs text-gray-600 dark:text-gray-400">
              {lastUpdateMethodAgentes}
            </div>
          )}
        </div>
      </div>

      {/* Filtro de Fechas */}
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4">
        <div className="flex flex-wrap items-end gap-3 text-sm">
          <div className="w-[160px] max-w-full">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
              Fecha Desde
            </label>
            <input
              type="date"
              value={fechaDesde}
              min={fechasDisponibles.fecha_min}
              max={fechasDisponibles.fecha_max}
              onChange={(e) => setFechaDesde(e.target.value)}
              className="w-full h-9 px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              data-testid="fecha-desde"
            />
          </div>
          
          <div className="w-[160px] max-w-full">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
              Fecha Hasta
            </label>
            <input
              type="date"
              value={fechaHasta}
              min={fechaDesde || fechasDisponibles.fecha_min}
              max={fechasDisponibles.fecha_max}
              onChange={(e) => setFechaHasta(e.target.value)}
              className="w-full h-9 px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              data-testid="fecha-hasta"
            />
          </div>

          <button
            onClick={() => {
              setFechaDesde(fechasDisponibles.fecha_min);
              setFechaHasta(fechasDisponibles.fecha_max);
            }}
            disabled={!fechasDisponibles.fecha_min}
            className="h-9 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-lg transition-colors disabled:opacity-50 whitespace-nowrap"
          >
            Todo el Rango
          </button>

          <button
            onClick={() => {
              setFechaDesde('');
              setFechaHasta('');
              setClubs([]);
            }}
            className="h-9 px-3 py-1.5 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors whitespace-nowrap"
          >
            Limpiar
          </button>
        </div>

        {/* Info de rango */}
        {fechasDisponibles.total_dias > 0 && (
          <div className="mt-3 text-xs text-gray-600 dark:text-gray-400">
            <Calendar className="w-4 h-4 inline mr-1" />
            Datos disponibles: <strong>{fechasDisponibles.fecha_min}</strong> a <strong>{fechasDisponibles.fecha_max}</strong> ({fechasDisponibles.total_dias} dias)
            {fechaDesde && fechaHasta && (
              <span className="inline-block sm:ml-4 text-blue-600 dark:text-blue-400 font-medium">
                Mostrando: {fechaDesde} a {fechaHasta}
              </span>
            )}
          </div>
        )}
      </div>

      {/* Mensaje cuando no hay filtro */}
      {(!fechaDesde || !fechaHasta) && (
        <div className="bg-gray-50 dark:bg-gray-800/50 border border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-6 text-center">
          <Calendar className="w-8 h-8 mx-auto text-gray-400 mb-3" />
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
            Selecciona un Rango de Fechas
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            Para ver los datos de clubs, agencias y jugadores, selecciona un rango de fechas arriba.
          </p>
          {fechasDisponibles.total_dias === 0 && (
            <p className="text-sm text-gray-500 dark:text-gray-500">
              No hay datos importados aun. Importa un archivo Excel para comenzar.
            </p>
          )}
        </div>
      )}

      {/* Tarjetas de resumen */}
      {clubs.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4 text-gray-900 dark:text-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 dark:text-gray-400 text-xs font-medium">Ganancia Total</p>
                <p className="text-2xl font-semibold tracking-tight tabular-nums mt-1">{formatNumber(totales.ganancia)}</p>
              </div>
              <TrendingDown className="w-7 h-7 text-gray-400 shrink-0" />
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4 text-gray-900 dark:text-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 dark:text-gray-400 text-xs font-medium">Cuota/Rake Total</p>
                <p className="text-2xl font-semibold tracking-tight tabular-nums mt-1">{formatNumber(totales.cuota_rake)}</p>
              </div>
              <TrendingUp className="w-7 h-7 text-gray-400 shrink-0" />
            </div>
          </div>

          <div className={`border ${totales.total >= 0 ? 'border-emerald-200 dark:border-emerald-800 text-emerald-700 dark:text-emerald-300' : 'border-red-200 dark:border-red-800 text-red-700 dark:text-red-300'} rounded-xl bg-white dark:bg-gray-800 p-4`}>
            <div className="flex items-center justify-between">
              <div>
                <p className={`text-gray-500 dark:text-gray-400 text-xs font-medium`}>Total Neto</p>
                <p className="text-2xl font-semibold tracking-tight tabular-nums mt-1">{formatNumber(totales.total)}</p>
              </div>
              {totales.total >= 0 ? (
                <TrendingUp className="w-7 h-7 text-gray-400 shrink-0" />
              ) : (
                <TrendingDown className="w-7 h-7 text-gray-400 shrink-0" />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Tabla de clubs */}
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Club
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  ID Club
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Ganancia
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Cuota/Rake
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Total
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider"
                  title="Saldo del club en su estado de cuenta del CRM">
                  Saldo financiero
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
              {loading ? (
                <tr>
                  <td colSpan="6" className="px-6 py-12 text-center">
                    <div className="flex items-center justify-center gap-2 text-gray-500">
                      <RefreshCw className="w-5 h-5 animate-spin" />
                      Cargando...
                    </div>
                  </td>
                </tr>
              ) : clubs.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-6 py-12 text-center text-gray-500 dark:text-gray-400">
                    <Upload className="w-12 h-12 mx-auto mb-3 opacity-50" />
                    <p>No hay datos disponibles</p>
                    <p className="text-sm mt-1">Importa un archivo Excel para comenzar</p>
                  </td>
                </tr>
              ) : (
                clubs.map((club) => (
                  <tr
                    key={club.id}
                    onClick={async () => {
                      setSelectedClub(club);
                      await loadAgencias(club.club_id);
                    }}
                    className="hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors cursor-pointer"
                    data-testid={`club-row-${club.club_id}`}
                  >
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                        {club.club_name}
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm text-gray-500 dark:text-gray-400">
                        {club.club_id}
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right">
                      <span className={`text-sm font-medium ${club.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                        {formatNumber(club.ganancia)}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right">
                      <span className="text-sm text-gray-900 dark:text-white">
                        {formatNumber(club.cuota_rake)}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right">
                      <span className={`text-sm font-bold ${club.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                        {formatNumber(club.total)}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right" data-testid={`club-saldo-fin-${club.club_id}`}>
                      {saldosFin[String(club.club_id)] ? (
                        <span className={`text-sm font-semibold ${saldosFin[String(club.club_id)].saldo < 0 ? 'text-red-600 dark:text-red-400' : 'text-emerald-600 dark:text-emerald-400'}`}
                          title={saldosFin[String(club.club_id)].cliente_nombre}>
                          {formatNumber(saldosFin[String(club.club_id)].saldo)}
                        </span>
                      ) : (
                        <span className="text-xs text-gray-400" title="Este club no está vinculado a un cliente del CRM">—</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            {clubs.length > 0 && (
              <tfoot className="bg-gray-100 dark:bg-gray-700 font-bold">
                <tr>
                  <td colSpan="2" className="px-6 py-4 text-sm text-gray-900 dark:text-white">
                    TOTALES ({clubs.length} clubs)
                  </td>
                  <td className="px-6 py-4 text-right">
                    <span className={`text-sm ${totales.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                      {formatNumber(totales.ganancia)}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right text-sm text-gray-900 dark:text-white">
                    {formatNumber(totales.cuota_rake)}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <span className={`text-sm ${totales.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                      {formatNumber(totales.total)}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-testid="clubs-total-saldo-fin">
                    <span className={`text-sm ${totalSaldoFin < 0 ? 'text-red-600 dark:text-red-400' : 'text-emerald-600 dark:text-emerald-400'}`}>
                      {formatNumber(totalSaldoFin)}
                    </span>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      {/* Modal/Seccion de Agencias */}
      {selectedClub && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-7xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header del modal */}
            <div className="bg-slate-800 dark:bg-slate-900 px-6 py-4 flex items-center justify-between">
              <div className="text-white">
                <h2 className="text-xl font-semibold">{selectedClub.club_name}</h2>
                <p className="text-white/80 text-sm">ID: {selectedClub.club_id}</p>
              </div>
              <button
                onClick={() => {
                  setSelectedClub(null);
                  setAgencias([]);
                }}
                className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                data-testid="btn-cerrar-club-modal"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Contenido */}
            <div className="p-4 sm:p-6 overflow-y-auto flex-1 min-h-0">
              {loadingAgencias ? (
                <div className="text-center py-12">
                  <RefreshCw className="w-12 h-12 animate-spin mx-auto text-gray-400 mb-4" />
                  <p className="text-gray-500">Cargando agencias...</p>
                </div>
              ) : agencias.length === 0 ? (
                <div className="text-center text-gray-500 dark:text-gray-400 py-12">
                  <Users className="w-16 h-16 mx-auto mb-4 opacity-50" />
                  <h3 className="text-xl font-semibold mb-2">No hay agencias</h3>
                  <p className="mb-4">No se encontraron agencias para este club</p>
                </div>
              ) : (
                <div>
                  {/* Titulo de la seccion */}
                  <div className="mb-4">
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                      <Users className="w-6 h-6" /> AGENCIAS
                      {agenciasSeleccionadas.length > 0 && (
                        <span className="text-sm font-normal text-orange-600 dark:text-orange-400">
                          ({agenciasSeleccionadas.length} seleccionadas)
                        </span>
                      )}
                    </h3>
                    
                    {/* Modal de configuracion de Rakeback */}
                    {mostrarConfigRakeback && (
                      <div className="mt-3 bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-400 dark:border-blue-600 rounded-lg p-4">
                        <div className="flex items-center justify-between mb-3">
                          <h4 className="font-bold text-gray-900 dark:text-white flex items-center gap-2">
                            <Settings className="w-5 h-5" />
                            Rakeback Predeterminado
                          </h4>
                          <button
                            onClick={() => setMostrarConfigRakeback(false)}
                            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        <div className="flex items-center gap-3">
                          <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            Porcentaje por defecto:
                          </label>
                          <input
                            type="number"
                            min="0"
                            max="100"
                            value={rakebackPorcentaje}
                            onChange={(e) => {
                              const val = Math.max(0, Math.min(100, parseInt(e.target.value) || 0));
                              setRakebackPorcentaje(val);
                            }}
                            className="w-20 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white text-center font-bold"
                          />
                          <span className="text-lg font-bold text-gray-900 dark:text-white">%</span>
                          <button
                            onClick={() => {
                              setRakebackPorcentaje(50);
                              toast.success('Rakeback predeterminado restaurado a 50%');
                            }}
                            className="ml-auto px-3 py-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 rounded text-sm"
                          >
                            Reset (50%)
                          </button>
                        </div>
                        <p className="text-xs text-gray-600 dark:text-gray-400 mt-2">
                          Este valor se aplica a agencias sin % configurado. Click en el icono de cada agencia para personalizar.
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Resumen del club */}
                  <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 mb-6">
                    <div className="grid grid-cols-3 gap-4 text-center">
                      <div>
                        <p className="text-xs text-gray-600 dark:text-gray-300">Ganancia</p>
                        <p className={`text-lg font-bold ${selectedClub.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                          {formatNumber(selectedClub.ganancia)}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-600 dark:text-gray-300">Cuota/Rake</p>
                        <p className="text-lg font-bold text-gray-900 dark:text-white">
                          {formatNumber(selectedClub.cuota_rake)}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-600 dark:text-gray-300">Total</p>
                        <p className={`text-lg font-bold ${selectedClub.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                          {formatNumber(selectedClub.total)}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Tabla de agencias - MODIFICADA con 2 columnas de iconos */}
                  <div className="bg-white dark:bg-gray-700 rounded-lg shadow overflow-x-auto">
                    <table className="w-full min-w-[1180px]">
                      <thead className="bg-gray-100 dark:bg-gray-600">
                        <tr>
                          <th className="px-2 py-3 text-center text-xs font-medium text-gray-600 dark:text-gray-200 uppercase w-12" title="Seleccionar agencia completa">
                            <CheckSquare className="w-4 h-4 mx-auto" />
                          </th>
                          <th className="px-2 py-3 text-center text-xs font-medium text-gray-600 dark:text-gray-200 uppercase w-12" title="Seleccionar jugadores">
                            <Users className="w-4 h-4 mx-auto" />
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-200 uppercase">
                            Agencia
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-200 uppercase">
                            ID Agencia
                          </th>
                          <th className="px-4 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-200 uppercase">
                            Ganancia
                          </th>
                          <th className="px-4 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-200 uppercase">
                            Cuota/Rake
                          </th>
                          <th className="px-4 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-200 uppercase">
                            Subtotal
                          </th>
                          <th className="px-4 py-3 text-center text-xs font-medium text-gray-600 dark:text-gray-200 uppercase">
                            <button
                              onClick={() => setMostrarConfigRakeback(!mostrarConfigRakeback)}
                              className="flex items-center gap-1 hover:text-orange-600 transition-colors mx-auto"
                              title="Configurar Rakeback"
                            >
                              <Settings className="w-4 h-4" />
                              Rakeback ({rakebackPorcentaje}%)
                            </button>
                          </th>
                          <th className="px-4 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-200 uppercase">
                            GAN + RBK
                          </th>
                          <th className="px-3 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-200 uppercase whitespace-nowrap" title="Resultado de blackjack de la agencia (apuestas + pagos) y % que le comparte el club">
                            Blackjack
                          </th>
                          <th className="px-3 py-3 text-center text-xs font-medium text-gray-600 dark:text-gray-200 uppercase whitespace-nowrap">
                            Ver
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                        {agencias.map((agencia) => {
                          const isSelected = agenciasSeleccionadas.find(a => a.agencia_id === agencia.agencia_id);
                          
                          return (
                            <tr key={agencia.id} className="hover:bg-orange-50 dark:hover:bg-orange-900/20 transition-colors">
                              {/* Columna 1: Seleccionar agencia completa (icono checkbox) */}
                              <td className="px-2 py-3 text-center">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleAgenciaSeleccion(agencia);
                                  }}
                                  className={`p-1 rounded-lg transition-all ${
                                    isSelected 
                                      ? 'bg-green-500 text-white hover:bg-green-600' 
                                      : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500'
                                  }`}
                                  title={isSelected ? 'Quitar agencia de seleccion' : 'Seleccionar agencia completa'}
                                  data-testid={`btn-select-agencia-${agencia.agencia_id}`}
                                >
                                  {isSelected ? <CheckSquare className="w-4 h-4" /> : <Square className="w-4 h-4" />}
                                </button>
                              </td>
                              
                              {/* Columna 2: Abrir modal seleccion de jugadores (icono +) */}
                              <td className="px-2 py-3 text-center">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    abrirModalSeleccionJugadores(agencia);
                                  }}
                                  className="p-1 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-all"
                                  title="Seleccionar jugadores y descargar Excel"
                                  data-testid={`btn-select-jugadores-${agencia.agencia_id}`}
                                >
                                  <Plus className="w-4 h-4" />
                                </button>
                              </td>
                              
                              {/* Columnas de datos (clicleables para ver jugadores) */}
                              <td 
                                onClick={async () => {
                                  setSelectedAgencia(agencia);
                                  setSearchJugadorId('');
                                  setLoadingJugadores(true);
                                  try {
                                    const response = await axios.get(`${API}/poker/agencias/${agencia.agencia_id}/jugadores-detallado?club_id=${selectedClub.club_id}&fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`);
                                    setJugadores(response.data);
                                    toast.success(`${response.data.length} registros de jugadores cargados`);
                                  } catch (error) {
                                    console.error('Error cargando jugadores:', error);
                                    toast.error('Error al cargar jugadores');
                                    setJugadores([]);
                                  } finally {
                                    setLoadingJugadores(false);
                                  }
                                }}
                                className="px-4 py-3 text-sm font-medium text-orange-600 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-300 cursor-pointer"
                              >
                                {agencia.agencia_name}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-500 dark:text-gray-300">
                                {agencia.agencia_id}
                              </td>
                              <td className="px-4 py-3 text-right text-sm">
                                <span className={`font-medium ${agencia.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                  {formatNumber(agencia.ganancia)}
                                </span>
                              </td>
                              <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                                {formatNumber(agencia.cuota_rake)}
                              </td>
                              <td className="px-4 py-3 text-right text-sm">
                                <span className={`font-bold ${agencia.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                  {formatNumber(agencia.total)}
                                </span>
                              </td>
                              
                              {/* Columna Rakeback % (editable) */}
                              <td className="px-4 py-3 text-center text-sm">
                                {editandoRakeback === agencia.agencia_id ? (
                                  <div className="flex items-center justify-center gap-2">
                                    <input
                                      type="number"
                                      min="0"
                                      max="100"
                                      defaultValue={getRakebackAgencia(agencia)}
                                      autoFocus
                                      onKeyDown={async (e) => {
                                        if (e.key === 'Enter') {
                                          const valor = Math.max(0, Math.min(100, parseInt(e.target.value) || 0));
                                          setEditandoRakeback(null);
                                          await saveRakebackToBackend(agencia.agencia_id, valor);
                                        } else if (e.key === 'Escape') {
                                          setEditandoRakeback(null);
                                        }
                                      }}
                                      className="w-16 px-2 py-1 border-2 border-blue-500 rounded text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-300"
                                    />
                                    <button
                                      onClick={() => setEditandoRakeback(null)}
                                      className="text-gray-500 hover:text-gray-700"
                                    >
                                      <X className="w-4 h-4" />
                                    </button>
                                  </div>
                                ) : (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setEditandoRakeback(agencia.agencia_id);
                                    }}
                                    className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 dark:bg-blue-900/40 rounded text-blue-800 dark:text-blue-300 font-medium hover:bg-blue-200 dark:hover:bg-blue-900/60 transition-colors group"
                                  >
                                    <Settings className="w-3 h-3" />
                                    {getRakebackAgencia(agencia)}%
                                    <Edit2 className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                                  </button>
                                )}
                              </td>
                              
                              {/* Columna GAN + RBK (suma el blackjack si está incluido) */}
                              <td className="px-4 py-3 text-right text-sm">
                                {(() => {
                                  const rbk = getRakebackAgencia(agencia);
                                  const bj = incluirBlackjack[agencia.agencia_id] ? (parseFloat(agencia.blackjack_monto) || 0) : 0;
                                  return <GanRbkConBj ganRbk={agencia.ganancia + (agencia.cuota_rake * (rbk / 100)) + bj} bj={bj} />;
                                })()}
                              </td>
                              
                              {/* Columna Blackjack */}
                              <td className="px-3 py-3 text-right whitespace-nowrap">
                                <AgenciaBlackjackCell
                                  agencia={agencia}
                                  incluido={incluirBlackjack[agencia.agencia_id]}
                                  onToggle={(v) => setIncluirBlackjack(prev => ({ ...prev, [agencia.agencia_id]: v }))}
                                  onSaved={loadAgencias}
                                />
                              </td>
                              
                              {/* Columna Acciones */}
                              <td className="px-3 py-3 text-center whitespace-nowrap">
                                <div className="flex items-center justify-center gap-1">
                                  {/* Boton Configurar Cliente - Solo admin */}
                                  {isAdmin && (<button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openConfigModal(agencia);
                                    }}
                                    className={`p-2 rounded-lg transition-colors inline-flex items-center justify-center ${
                                      agenciaClienteConfigs[agencia.agencia_id]
                                        ? 'bg-purple-500 hover:bg-purple-600 text-white'
                                        : 'bg-gray-300 hover:bg-gray-400 text-gray-700'
                                    }`}
                                    title={agenciaClienteConfigs[agencia.agencia_id] 
                                      ? `Configurado: ${agenciaClienteConfigs[agencia.agencia_id].cliente_name || 'Cliente'}` 
                                      : 'Configurar Cliente'}
                                  >
                                    {agenciaClienteConfigs[agencia.agencia_id] ? <Link2 className="w-4 h-4" /> : <Settings className="w-4 h-4" />}
                                  </button>)}
                                  
                                  {/* Boton Ver Resumen */}
                                  <button
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      setAgenciaResumen(agencia);
                                      setLoadingResumen(true);
                                      try {
                                        const response = await axios.get(`${API}/poker/agencias/${agencia.agencia_id}/jugadores-detallado?fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`);
                                        setJugadoresResumen(response.data);
                                        toast.success('Resumen de ciclo cargado');
                                      } catch (error) {
                                        console.error('Error cargando resumen:', error);
                                        toast.error('Error al cargar resumen');
                                        setJugadoresResumen([]);
                                      } finally {
                                        setLoadingResumen(false);
                                      }
                                    }}
                                    className="p-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors inline-flex items-center justify-center"
                                    title="Ver Resumen de Ciclo"
                                  >
                                    <Eye className="w-4 h-4" />
                                  </button>
                                  
                                  {/* Boton WhatsApp - Solo admin */}
                                  {isAdmin && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      enviarCierreWhatsapp(agencia);
                                    }}
                                    disabled={!agenciaClienteConfigs[agencia.agencia_id]?.has_whatsapp || enviandoWhatsapp === agencia.agencia_id}
                                    className={`p-2 rounded-lg transition-colors inline-flex items-center justify-center ${
                                      agenciaClienteConfigs[agencia.agencia_id]?.has_whatsapp
                                        ? 'bg-green-500 hover:bg-green-600 text-white'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    }`}
                                    title={
                                      !agenciaClienteConfigs[agencia.agencia_id]
                                        ? 'Configura primero el cliente'
                                        : !agenciaClienteConfigs[agencia.agencia_id]?.has_whatsapp
                                        ? 'Cliente sin WhatsApp configurado'
                                        : 'Enviar Cierre por WhatsApp'
                                    }
                                  >
                                    {enviandoWhatsapp === agencia.agencia_id ? (
                                      <RefreshCw className="w-4 h-4 animate-spin" />
                                    ) : (
                                      <MessageCircle className="w-4 h-4" />
                                    )}
                                  </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot className="bg-gray-100 dark:bg-gray-600 font-bold">
                        <tr>
                          <td className="px-2 py-3"></td>
                          <td className="px-2 py-3"></td>
                          <td colSpan="2" className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                            TOTALES ({agencias.length} agencias)
                          </td>
                          <td className="px-4 py-3 text-right text-sm">
                            <span className={`${agencias.reduce((sum, a) => sum + a.ganancia, 0) < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                              {formatNumber(agencias.reduce((sum, a) => sum + a.ganancia, 0))}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                            {formatNumber(agencias.reduce((sum, a) => sum + a.cuota_rake, 0))}
                          </td>
                          <td className="px-4 py-3 text-right text-sm">
                            <span className={`${agencias.reduce((sum, a) => sum + a.total, 0) < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                              {formatNumber(agencias.reduce((sum, a) => sum + a.total, 0))}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-gray-500 dark:text-gray-400">
                            Variable
                          </td>
                          <td className="px-4 py-3 text-right text-sm">
                            {(() => {
                              const totalGanRbk = agencias.reduce((sum, a) => {
                                const rbk = getRakebackAgencia(a);
                                const bj = incluirBlackjack[a.agencia_id] ? (parseFloat(a.blackjack_monto) || 0) : 0;
                                return sum + a.ganancia + (a.cuota_rake * (rbk / 100)) + bj;
                              }, 0);
                              return (
                                <span className={`text-lg ${totalGanRbk < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                  {formatNumber(totalGanRbk)}
                                </span>
                              );
                            })()}
                          </td>
                          <td className="px-4 py-3 text-right text-sm">
                            {(() => {
                              const totalBj = agencias.reduce((sum, a) => sum + (a.blackjack_resultado || 0), 0);
                              return (
                                <span className={totalBj < 0 ? 'text-red-600 dark:text-red-400' : 'text-emerald-600 dark:text-emerald-400'}>
                                  {formatNumber(totalBj)}
                                </span>
                              );
                            })()}
                          </td>
                          <td className="px-4 py-3"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Cuadro flotante de totales de agencias seleccionadas */}
      {agenciasSeleccionadas.length > 0 && (
        <div className="fixed bottom-6 right-6 z-[55] animate-in slide-in-from-bottom">
          <div className="bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl shadow-2xl p-6 text-white min-w-[320px]">
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-lg font-bold flex items-center gap-2">
                <CheckSquare className="w-5 h-5" />
                Agencias Seleccionadas
              </h4>
              <div className="flex items-center gap-2">
                <button
                  onClick={descargarExcelCierreCiclo}
                  disabled={descargandoExcelCierre}
                  className="text-white/80 hover:text-white hover:bg-white/20 rounded-lg p-1 transition-colors"
                  title="Descargar Excel"
                  data-testid="btn-excel-cierre-ciclo"
                >
                  {descargandoExcelCierre ? <RefreshCw className="w-5 h-5 animate-spin" /> : <Download className="w-5 h-5" />}
                </button>
                <button
                  onClick={exportarPDFCierreCiclo}
                  className="text-white/80 hover:text-white hover:bg-white/20 rounded-lg p-1 transition-colors"
                  title="Exportar PDF"
                >
                  <FileText className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setAgenciasSeleccionadas([])}
                  className="text-white/80 hover:text-white hover:bg-white/20 rounded-lg p-1 transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="text-xs text-white/80 mb-2">
                {fechaDesde} al {fechaHasta}
              </div>
              <div className="text-sm text-white/90">
                {agenciasSeleccionadas.length} {agenciasSeleccionadas.length === 1 ? 'agencia' : 'agencias'}
              </div>
              
              <div className="bg-white/20 rounded-lg p-3 space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-white/90 text-sm">Ganancia:</span>
                  <span className={`font-bold text-lg ${calcularTotalesSeleccionadas().ganancia < 0 ? 'text-red-200' : 'text-green-200'}`}>
                    {formatNumber(calcularTotalesSeleccionadas().ganancia)}
                  </span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="text-white/90 text-sm">Cuota/Rake:</span>
                  <span className="font-bold text-lg">
                    {formatNumber(calcularTotalesSeleccionadas().cuota_rake)}
                  </span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="text-white/90 text-sm">Subtotal:</span>
                  <span className={`font-bold text-lg ${calcularTotalesSeleccionadas().total < 0 ? 'text-red-200' : 'text-green-200'}`}>
                    {formatNumber(calcularTotalesSeleccionadas().total)}
                  </span>
                </div>
                
                <div className="border-t border-white/30 pt-2 mt-2"></div>
                
                <div className="flex justify-between items-center bg-white/10 rounded p-2">
                  <span className="text-white/90 text-sm flex items-center gap-1">
                    <Settings className="w-4 h-4" />
                    Rakeback:
                  </span>
                  <span className="font-bold text-lg">
                    Individual
                  </span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="text-white font-semibold">GAN + RBK:</span>
                  <span className={`font-bold text-2xl ${calcularTotalesSeleccionadas().ganRbk < 0 ? 'text-red-200' : 'text-green-200'}`}>
                    {formatNumber(calcularTotalesSeleccionadas().ganRbk)}
                  </span>
                </div>
              </div>

              {/* Lista de agencias seleccionadas con detalle expandible */}
              <div className="mt-4 max-h-[400px] overflow-y-auto space-y-2">
                {agenciasSeleccionadas.map((agencia) => {
                  const rbk = getRakebackAgencia(agencia);
                  const rakebackMonto = agencia.cuota_rake * (rbk / 100);
                  const ganRbk = agencia.ganancia + rakebackMonto;
                  const isExpanded = agenciasExpandidas.includes(agencia.agencia_id);
                  
                  return (
                    <div key={agencia.agencia_id} className="bg-white/10 rounded-lg overflow-hidden">
                      {/* Header de la agencia */}
                      <div 
                        className="flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-white/20 transition-colors"
                        onClick={() => toggleExpandAgencia(agencia.agencia_id)}
                      >
                        <div className="flex items-center gap-2 flex-1">
                          <ChevronDown className={`w-4 h-4 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                          <span className="text-sm font-medium">{agencia.agencia_name}</span>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleAgenciaSeleccion(agencia);
                          }}
                          className="text-white/60 hover:text-white ml-2"
                        >
                          <Minus className="w-3 h-3" />
                        </button>
                      </div>
                      
                      {/* Detalle expandible */}
                      {isExpanded && (
                        <div className="px-3 pb-3 pt-1 space-y-1 text-xs border-t border-white/20">
                          {(() => {
                            const custom = agenciasJugadoresCustom[agencia.agencia_id];
                            const gan = custom ? custom.totales.ganancia : agencia.ganancia;
                            const cr = custom ? custom.totales.cuota_rake : agencia.cuota_rake;
                            const tot = custom ? custom.totales.total : agencia.total;
                            return (
                              <>
                                <div className="flex justify-between">
                                  <span className="text-white/70">Ganancia:</span>
                                  <span className={gan < 0 ? 'text-red-200' : 'text-green-200'}>
                                    {formatNumber(gan)}
                                  </span>
                                </div>
                                <div className="flex justify-between">
                                  <span className="text-white/70">Cuota/Rake:</span>
                                  <span>{formatNumber(cr)}</span>
                                </div>
                                <div className="flex justify-between">
                                  <span className="text-white/70">Subtotal:</span>
                                  <span className={tot < 0 ? 'text-red-200' : 'text-green-200'}>
                                    {formatNumber(tot)}
                                  </span>
                                </div>
                                {custom && (
                                  <div className="text-xs text-amber-300 mt-1">
                                    {custom.jugador_ids.length} jugadores seleccionados
                                  </div>
                                )}
                              </>
                            );
                          })()}
                          <div className="flex justify-between bg-white/10 rounded px-2 py-1 mt-1">
                            <span className="text-white/70">Rakeback ({rbk}%):</span>
                            <span className="text-blue-200">{formatNumber(rakebackMonto)}</span>
                          </div>
                          <div className="flex justify-between font-bold text-sm pt-1 border-t border-white/20">
                            <span>GAN + RBK:</span>
                            {(() => {
                              const custom = agenciasJugadoresCustom[agencia.agencia_id];
                              const g = custom ? custom.totales.ganancia : agencia.ganancia;
                              const c = custom ? custom.totales.cuota_rake : agencia.cuota_rake;
                              const gr = g + (c * (rbk / 100));
                              return (
                                <span className={gr < 0 ? 'text-red-200' : 'text-green-200'}>
                                  {formatNumber(gr)}
                                </span>
                              );
                            })()}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Jugadores (vista detallada al hacer click en nombre de agencia) */}
      {selectedAgencia && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header con breadcrumbs */}
            <div className="bg-slate-800 dark:bg-slate-900 px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="text-white">
                  {/* Breadcrumb */}
                  <div className="flex items-center gap-2 text-sm mb-2 text-white/80">
                    <span>{selectedClub.club_name}</span>
                    <span>&rsaquo;</span>
                    <span>{selectedAgencia.agencia_name}</span>
                    <span>&rsaquo;</span>
                    <span className="text-white font-semibold">Jugadores</span>
                  </div>
                  <h2 className="text-xl font-semibold">{selectedAgencia.agencia_name}</h2>
                  <p className="text-white/80 text-sm">ID: {selectedAgencia.agencia_id} | {jugadores.length} jugadores</p>
                </div>
                <button
                  onClick={() => {
                    setSelectedAgencia(null);
                    setJugadores([]);
                  }}
                  className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>

            {/* Contenido */}
            <div className="p-4 sm:p-6 overflow-y-auto flex-1 min-h-0">
              {loadingJugadores ? (
                <div className="text-center py-12">
                  <RefreshCw className="w-12 h-12 animate-spin mx-auto text-gray-400 mb-4" />
                  <p className="text-gray-500">Cargando jugadores...</p>
                </div>
              ) : jugadores.length === 0 ? (
                <div className="text-center text-gray-500 dark:text-gray-400 py-12">
                  <Users className="w-16 h-16 mx-auto mb-4 opacity-50" />
                  <h3 className="text-xl font-semibold mb-2">No hay jugadores</h3>
                  <p className="mb-4">No se encontraron jugadores para esta agencia en este rango de fechas</p>
                </div>
              ) : (
                <div>
                  {/* Resumen de la agencia */}
                  <div className="bg-gradient-to-r from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 rounded-lg p-4 mb-6">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div>
                        <p className="text-xs text-gray-600 dark:text-gray-300">Ganancia Total</p>
                        <p className={`text-lg font-bold ${selectedAgencia.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                          {formatNumber(selectedAgencia.ganancia)}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-600 dark:text-gray-300">Cuota/Rake Total</p>
                        <p className="text-lg font-bold text-gray-900 dark:text-white">
                          {formatNumber(selectedAgencia.cuota_rake)}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-600 dark:text-gray-300">Total Acumulado</p>
                        <p className={`text-lg font-bold ${selectedAgencia.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                          {formatNumber(selectedAgencia.total)}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-600 dark:text-gray-300">Registros</p>
                        <p className="text-lg font-bold text-gray-900 dark:text-white">
                          {jugadores.length}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Buscador de jugador por ID */}
                  <div className="mb-6">
                    <div className="flex gap-2 mb-3">
                      <div className="flex-1 relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                        <input
                          type="text"
                          placeholder="Buscar por ultimos 4 digitos del ID (ej: 9190)"
                          value={searchJugadorId}
                          onChange={(e) => setSearchJugadorId(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter' && searchJugadorId) {
                              document.getElementById('btn-buscar-jugador').click();
                            }
                          }}
                          className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-white"
                        />
                      </div>
                      {searchJugadorId && (
                        <button
                          id="btn-buscar-jugador"
                          onClick={async () => {
                            setLoadingJugadores(true);
                            try {
                              const response = await axios.get(`${API}/poker/agencias/${selectedAgencia.agencia_id}/jugadores-detallado?club_id=${selectedClub.club_id}&fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}&jugador_id=${searchJugadorId}`);
                              setJugadores(response.data);
                              if (response.data.length === 0) {
                                toast.error(`No se encontraron jugadores con ID terminado en ${searchJugadorId}`);
                              } else {
                                toast.success(`${response.data.length} registros encontrados`);
                              }
                            } catch (error) {
                              toast.error('Error buscando jugador');
                            } finally {
                              setLoadingJugadores(false);
                            }
                          }}
                          className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors"
                        >
                          Buscar
                        </button>
                      )}
                      {searchJugadorId && (
                        <button
                          onClick={async () => {
                            setSearchJugadorId('');
                            setLoadingJugadores(true);
                            try {
                              const response = await axios.get(`${API}/poker/agencias/${selectedAgencia.agencia_id}/jugadores-detallado?fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`);
                              setJugadores(response.data);
                              toast.success('Mostrando todos los jugadores');
                            } catch (error) {
                              toast.error('Error cargando jugadores');
                            } finally {
                              setLoadingJugadores(false);
                            }
                          }}
                          className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors"
                        >
                          Limpiar
                        </button>
                      )}
                    </div>
                    
                    {/* Botones de Screenshot y Excel Cruce */}
                    {jugadores.length > 0 && (
                      <div className="flex gap-2 flex-wrap">
                        <button
                          onClick={captureScreenshot}
                          className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors shadow-md"
                        >
                          <Camera className="w-4 h-4" />
                          Capturar Screenshot
                        </button>
                        <button
                          onClick={() => descargarExcelCruce(selectedAgencia)}
                          disabled={descargandoExcelCruce}
                          className="flex items-center gap-2 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors shadow-md disabled:opacity-50"
                          data-testid="btn-excel-cruce"
                        >
                          {descargandoExcelCruce ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
                          {descargandoExcelCruce ? 'Generando...' : 'Excel Cruce IDs'}
                        </button>
                        <button
                          onClick={abrirTop5Modal}
                          className="flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg transition-colors shadow-md"
                          data-testid="btn-top5-jugadores"
                        >
                          <Trophy className="w-4 h-4" />
                          Top 5 Jugadores
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Vista: Lista simple cuando hay busqueda activa */}
                  {searchJugadorId ? (
                    <div ref={screenshotRef} className="bg-white dark:bg-gray-700 rounded-lg shadow overflow-hidden border-2 border-purple-500">
                      <div className="bg-slate-800 dark:bg-slate-900 px-4 py-3 text-white">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <Search className="w-5 h-5" />
                            <span className="font-bold">
                              Resultados para ID terminado en &quot;{searchJugadorId}&quot;
                            </span>
                          </div>
                          <span className="text-purple-100">
                            {jugadores.length} {jugadores.length === 1 ? 'registro' : 'registros'}
                          </span>
                        </div>
                      </div>

                      <table className="w-full">
                        <thead className="bg-gray-50 dark:bg-gray-800">
                          <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Fecha</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">ID</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Jugador</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Ganancia</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Cuota</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Total</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                          {jugadores.map((jugador) => (
                            <tr key={jugador.id} className="hover:bg-purple-50 dark:hover:bg-purple-900/10">
                              <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400">
                                {new Date(jugador.fecha + 'T00:00:00').toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                              </td>
                              <td className="px-4 py-3 text-sm font-mono text-gray-500 dark:text-gray-400">{jugador.jugador_id}</td>
                              <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">{jugador.jugador_name}</td>
                              <td className="px-4 py-3 text-right text-sm">
                                <span className={`${jugador.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                  {formatNumber(jugador.ganancia)}
                                </span>
                              </td>
                              <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                                {formatNumber(jugador.cuota_rake)}
                              </td>
                              <td className="px-4 py-3 text-right text-sm">
                                <span className={`font-bold ${jugador.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                  {formatNumber(jugador.total)}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot className="bg-purple-100 dark:bg-purple-900/40 font-bold">
                          <tr>
                            <td colSpan="3" className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                              TOTALES
                            </td>
                            <td className="px-4 py-3 text-right text-sm">
                              <span className={`${jugadores.reduce((sum, j) => sum + j.ganancia, 0) < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                {formatNumber(jugadores.reduce((sum, j) => sum + j.ganancia, 0))}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                              {formatNumber(jugadores.reduce((sum, j) => sum + j.cuota_rake, 0))}
                            </td>
                            <td className="px-4 py-3 text-right text-sm">
                              <span className={`${jugadores.reduce((sum, j) => sum + j.total, 0) < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                {formatNumber(jugadores.reduce((sum, j) => sum + j.total, 0))}
                              </span>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  ) : (
                    /* Vista: Agrupada por fecha (vista normal) */
                    (() => {
                      const jugadoresPorFecha = jugadores.reduce((acc, jugador) => {
                      if (!acc[jugador.fecha]) {
                        acc[jugador.fecha] = [];
                      }
                      acc[jugador.fecha].push(jugador);
                      return acc;
                    }, {});

                    const fechasOrdenadas = Object.keys(jugadoresPorFecha).sort();

                    return (
                      <div className="space-y-4">
                        {fechasOrdenadas.map((fecha) => {
                          const jugadoresDia = jugadoresPorFecha[fecha];
                          const subtotalGanancia = jugadoresDia.reduce((sum, j) => sum + j.ganancia, 0);
                          const subtotalCuota = jugadoresDia.reduce((sum, j) => sum + j.cuota_rake, 0);
                          const subtotalTotal = subtotalGanancia + subtotalCuota;

                          return (
                            <div key={fecha} className="bg-white dark:bg-gray-700 rounded-lg shadow overflow-hidden border-2 border-purple-200 dark:border-purple-800">
                              <div className="bg-gradient-to-r from-purple-100 to-indigo-100 dark:from-purple-900/40 dark:to-indigo-900/40 px-4 py-3 flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                  <Calendar className="w-5 h-5 text-purple-600 dark:text-purple-400" />
                                  <span className="font-bold text-gray-900 dark:text-white">
                                    {new Date(fecha + 'T00:00:00').toLocaleDateString('es-AR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                                  </span>
                                  <span className="text-sm text-gray-600 dark:text-gray-400">
                                    ({jugadoresDia.length} {jugadoresDia.length === 1 ? 'jugador' : 'jugadores'})
                                  </span>
                                </div>
                                <div className="text-right">
                                  <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Subtotal: </span>
                                  <span className={`font-bold ${subtotalTotal < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                    {formatNumber(subtotalTotal)}
                                  </span>
                                </div>
                              </div>

                              <table className="w-full">
                                <thead className="bg-gray-50 dark:bg-gray-800">
                                  <tr>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">ID</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Jugador</th>
                                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Ganancia</th>
                                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Cuota</th>
                                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Total</th>
                                  </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                                  {jugadoresDia.map((jugador) => (
                                    <tr key={jugador.id} className="hover:bg-purple-50 dark:hover:bg-purple-900/10">
                                      <td className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">{jugador.jugador_id}</td>
                                      <td className="px-4 py-2 text-sm font-medium text-gray-900 dark:text-white">{jugador.jugador_name}</td>
                                      <td className="px-4 py-2 text-right text-sm">
                                        <span className={`${jugador.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                          {formatNumber(jugador.ganancia)}
                                        </span>
                                      </td>
                                      <td className="px-4 py-2 text-right text-sm text-gray-900 dark:text-white">
                                        {formatNumber(jugador.cuota_rake)}
                                      </td>
                                      <td className="px-4 py-2 text-right text-sm">
                                        <span className={`font-bold ${jugador.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                          {formatNumber(jugador.total)}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                                <tfoot className="bg-purple-50 dark:bg-purple-900/20 font-bold">
                                  <tr>
                                    <td colSpan="2" className="px-4 py-2 text-sm text-gray-900 dark:text-white">
                                      Subtotal del dia
                                    </td>
                                    <td className="px-4 py-2 text-right text-sm">
                                      <span className={`${subtotalGanancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                        {formatNumber(subtotalGanancia)}
                                      </span>
                                    </td>
                                    <td className="px-4 py-2 text-right text-sm text-gray-900 dark:text-white">
                                      {formatNumber(subtotalCuota)}
                                    </td>
                                    <td className="px-4 py-2 text-right text-sm">
                                      <span className={`${subtotalTotal < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                        {formatNumber(subtotalTotal)}
                                      </span>
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          );
                        })}

                        {/* Total Acumulado de todos los dias */}
                        {fechasOrdenadas.length > 1 && (
                          <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg shadow-lg p-6 text-white">
                            <div className="grid grid-cols-3 gap-4 text-center">
                              <div>
                                <p className="text-purple-100 text-sm mb-1">Total Acumulado</p>
                                <p className="text-3xl font-bold">
                                  {formatNumber(jugadores.reduce((sum, j) => sum + j.total, 0))}
                                </p>
                              </div>
                              <div>
                                <p className="text-purple-100 text-sm mb-1">Ganancia</p>
                                <p className="text-xl font-semibold">
                                  {formatNumber(jugadores.reduce((sum, j) => sum + j.ganancia, 0))}
                                </p>
                              </div>
                              <div>
                                <p className="text-purple-100 text-sm mb-1">Cuota</p>
                                <p className="text-xl font-semibold">
                                  {formatNumber(jugadores.reduce((sum, j) => sum + j.cuota_rake, 0))}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })()
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal de Configuracion Agencia-Cliente */}
      {showConfigModal && configAgencia && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[80] p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-md overflow-hidden">
            <div className="bg-slate-800 dark:bg-slate-900 px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="text-white">
                  <h2 className="text-xl font-bold flex items-center gap-2">
                    <Link2 className="w-6 h-6" />
                    Configurar Cliente
                  </h2>
                  <p className="text-purple-100 text-sm mt-1">{configAgencia.agencia_name}</p>
                </div>
                <button
                  onClick={() => {
                    setShowConfigModal(false);
                    setConfigAgencia(null);
                    setSelectedCartera('');
                    setSelectedCliente('');
                  }}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>
            
            <div className="p-6">
              {loadingConfig ? (
                <div className="flex items-center justify-center py-8">
                  <RefreshCw className="w-8 h-8 animate-spin text-purple-500" />
                </div>
              ) : (
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Cartera
                    </label>
                    <select
                      value={selectedCartera}
                      onChange={(e) => {
                        setSelectedCartera(e.target.value);
                        setSelectedCliente('');
                      }}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500"
                    >
                      <option value="">Seleccionar cartera...</option>
                      {carterasConClientes.map(cartera => (
                        <option key={cartera.id} value={cartera.id}>
                          {cartera.name} ({cartera.clientes?.length || 0} clientes)
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  {selectedCartera && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Cliente
                      </label>
                      <select
                        value={selectedCliente}
                        onChange={(e) => setSelectedCliente(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">Seleccionar cliente...</option>
                        {carterasConClientes
                          .find(c => c.id === selectedCartera)
                          ?.clientes?.map(cliente => (
                            <option key={cliente.id} value={cliente.id}>
                              {cliente.name}
                            </option>
                          ))
                        }
                      </select>
                    </div>
                  )}
                  
                  {agenciaClienteConfigs[configAgencia.agencia_id] && (
                    <div className="mt-4 p-3 bg-purple-50 dark:bg-purple-900/20 rounded-lg">
                      <p className="text-sm text-purple-700 dark:text-purple-300">
                        <strong>Configuracion actual:</strong><br />
                        Cliente: {agenciaClienteConfigs[configAgencia.agencia_id].cliente_name}<br />
                        WhatsApp: {agenciaClienteConfigs[configAgencia.agencia_id].has_whatsapp ? 'Configurado' : 'No configurado'}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
            
            <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-between">
              {agenciaClienteConfigs[configAgencia.agencia_id] && (
                <button
                  onClick={deleteAgenciaClienteConfig}
                  disabled={loadingConfig}
                  className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors flex items-center gap-2"
                >
                  <Unlink className="w-4 h-4" />
                  Desvincular
                </button>
              )}
              <div className="flex gap-2 ml-auto">
                <button
                  onClick={() => {
                    setShowConfigModal(false);
                    setConfigAgencia(null);
                  }}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={saveAgenciaClienteConfig}
                  disabled={!selectedCliente || loadingConfig}
                  className="px-4 py-2 bg-purple-500 hover:bg-purple-600 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  <Link2 className="w-4 h-4" />
                  Vincular
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Resumen de Ciclo */}
      {agenciaResumen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[70] p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col">
            <div className="bg-slate-800 dark:bg-slate-900 px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="text-white">
                  <h2 className="text-xl font-semibold flex items-center gap-2">
                    <FileText className="w-7 h-7" />
                    Resumen de Ciclo
                  </h2>
                  <p className="text-white/80 text-sm mt-1">
                    {agenciaResumen.agencia_name} | {fechaDesde} a {fechaHasta}
                  </p>
                </div>
                <button
                  onClick={() => {
                    setAgenciaResumen(null);
                    setJugadoresResumen([]);
                  }}
                  className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="p-4 sm:p-6 overflow-y-auto flex-1 min-h-0">
              {loadingResumen ? (
                <div className="text-center py-12">
                  <RefreshCw className="w-12 h-12 animate-spin mx-auto text-gray-400 mb-4" />
                  <p className="text-gray-500">Cargando resumen...</p>
                </div>
              ) : (
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4">
                      Informacion de la Agencia
                    </h3>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <p className="text-gray-600 dark:text-gray-400">Agencia:</p>
                        <p className="font-semibold text-gray-900 dark:text-white">{agenciaResumen.agencia_name}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 dark:text-gray-400">ID Agencia:</p>
                        <p className="font-semibold text-gray-900 dark:text-white">{agenciaResumen.agencia_id}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 dark:text-gray-400">Club:</p>
                        <p className="font-semibold text-gray-900 dark:text-white">{selectedClub?.club_name || 'N/A'}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 dark:text-gray-400">Periodo:</p>
                        <p className="font-semibold text-gray-900 dark:text-white">{fechaDesde} a {fechaHasta}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4">
                      Totales del Periodo
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                      <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                        <p className="text-xs text-gray-600 dark:text-gray-300 mb-1">Ganancia</p>
                        <p className={`text-xl font-bold ${agenciaResumen.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                          {formatNumber(agenciaResumen.ganancia)}
                        </p>
                      </div>
                      <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                        <p className="text-xs text-gray-600 dark:text-gray-300 mb-1">Cuota/Rake</p>
                        <p className="text-xl font-bold text-gray-900 dark:text-white">
                          {formatNumber(agenciaResumen.cuota_rake)}
                        </p>
                      </div>
                      <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                        <p className="text-xs text-gray-600 dark:text-gray-300 mb-1">Subtotal</p>
                        <p className={`text-xl font-bold ${agenciaResumen.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                          {formatNumber(agenciaResumen.total)}
                        </p>
                      </div>
                      <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                        <p className="text-xs text-gray-600 dark:text-gray-300 mb-1">Rakeback</p>
                        <p className="text-xl font-bold text-blue-600 dark:text-blue-400">
                          {getRakebackAgencia(agenciaResumen)}%
                        </p>
                      </div>
                      <div className="bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                        <p className="text-xs text-gray-600 dark:text-gray-300 mb-1">GAN + RBK</p>
                        {(() => {
                          const rbk = getRakebackAgencia(agenciaResumen);
                          const ganRbk = agenciaResumen.ganancia + (agenciaResumen.cuota_rake * (rbk / 100));
                          return (
                            <p className={`text-xl font-bold ${ganRbk < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                              {formatNumber(ganRbk)}
                            </p>
                          );
                        })()}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                        Detalle de Jugadores ({jugadoresResumen.length})
                      </h3>
                      <button
                        onClick={exportarResumenPDF}
                        className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors shadow-md"
                      >
                        <Download className="w-4 h-4" />
                        Exportar PDF
                      </button>
                    </div>

                    {jugadoresResumen.length === 0 ? (
                      <div className="text-center text-gray-500 dark:text-gray-400 py-8">
                        <Users className="w-12 h-12 mx-auto mb-3 opacity-50" />
                        <p>No hay jugadores en este periodo</p>
                      </div>
                    ) : (
                      <div className="bg-white dark:bg-gray-700 rounded-lg shadow overflow-hidden max-h-96 overflow-y-auto">
                        <table className="w-full">
                          <thead className="bg-gray-100 dark:bg-gray-600 sticky top-0">
                            <tr>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Fecha</th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">ID</th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Jugador</th>
                              <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Ganancia</th>
                              <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Cuota</th>
                              <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Total</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                            {jugadoresResumen.map((jugador) => (
                              <tr key={jugador.id} className="hover:bg-blue-50 dark:hover:bg-blue-900/10">
                                <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">
                                  {new Date(jugador.fecha + 'T00:00:00').toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                </td>
                                <td className="px-4 py-3 text-sm font-mono text-gray-500 dark:text-gray-400">{jugador.jugador_id}</td>
                                <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">{jugador.jugador_name}</td>
                                <td className="px-4 py-3 text-right text-sm">
                                  <span className={`${jugador.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                    {formatNumber(jugador.ganancia)}
                                  </span>
                                </td>
                                <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                                  {formatNumber(jugador.cuota_rake)}
                                </td>
                                <td className="px-4 py-3 text-right text-sm">
                                  <span className={`font-bold ${jugador.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                    {formatNumber(jugador.total)}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot className="bg-blue-100 dark:bg-blue-900/40 font-bold sticky bottom-0">
                            <tr>
                              <td colSpan="3" className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                                TOTALES
                              </td>
                              <td className="px-4 py-3 text-right text-sm">
                                <span className={`${jugadoresResumen.reduce((sum, j) => sum + j.ganancia, 0) < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                  {formatNumber(jugadoresResumen.reduce((sum, j) => sum + j.ganancia, 0))}
                                </span>
                              </td>
                              <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                                {formatNumber(jugadoresResumen.reduce((sum, j) => sum + j.cuota_rake, 0))}
                              </td>
                              <td className="px-4 py-3 text-right text-sm">
                                <span className={`${jugadoresResumen.reduce((sum, j) => sum + j.total, 0) < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                  {formatNumber(jugadoresResumen.reduce((sum, j) => sum + j.total, 0))}
                                </span>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* === NUEVO MODAL: Seleccion de Jugadores y Descarga Excel === */}
      {showJugadoresSelectModal && jugadoresSelectAgencia && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[75] p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="bg-slate-800 dark:bg-slate-900 px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="text-white">
                  <h2 className="text-xl font-bold flex items-center gap-2">
                    <Users className="w-6 h-6" />
                    Seleccionar Jugadores
                  </h2>
                  <p className="text-orange-100 text-sm mt-1">
                    {jugadoresSelectAgencia.agencia_name} | {fechaDesde} a {fechaHasta}
                  </p>
                </div>
                <button
                  onClick={() => {
                    setShowJugadoresSelectModal(false);
                    setJugadoresSelectAgencia(null);
                    setJugadoresParaSeleccionar([]);
                    setJugadoresSeleccionados({});
                  }}
                  className="text-white/80 hover:text-white transition-colors"
                  data-testid="btn-cerrar-select-jugadores"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>
            
            {/* Toolbar */}
            <div className="px-6 py-3 bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600 flex items-center justify-between flex-wrap gap-3">
              <div className="flex items-center gap-3">
                <button
                  onClick={toggleTodosJugadores}
                  className="flex items-center gap-2 px-3 py-2 bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 rounded-lg text-sm font-medium transition-colors"
                  data-testid="btn-toggle-todos-jugadores"
                >
                  {(() => {
                    const uniqueIds = {};
                    jugadoresParaSeleccionar.forEach(j => { uniqueIds[j.jugador_id] = true; });
                    const todosSeleccionados = Object.keys(uniqueIds).length > 0 && Object.keys(uniqueIds).every(id => jugadoresSeleccionados[id]);
                    return todosSeleccionados ? (
                      <><CheckSquare className="w-4 h-4 text-green-600" /> Deseleccionar Todos</>
                    ) : (
                      <><Square className="w-4 h-4" /> Seleccionar Todos</>
                    );
                  })()}
                </button>
                <span className="text-sm text-gray-600 dark:text-gray-300">
                  {Object.keys(jugadoresSeleccionados).length} de {getJugadoresUnicos().length} jugadores seleccionados
                </span>
              </div>
              
              <button
                onClick={() => { aplicarSeleccionJugadores(); }}
                disabled={Object.keys(jugadoresSeleccionados).length === 0}
                className="flex items-center gap-2 px-3 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-md font-medium"
                data-testid="btn-aplicar-seleccion"
              >
                <CheckSquare className="w-4 h-4" />
                Aplicar
              </button>
              <button
                onClick={descargarExcelJugadores}
                disabled={Object.keys(jugadoresSeleccionados).length === 0 || descargandoExcel}
                className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-md font-medium"
                data-testid="btn-descargar-excel"
              >
                {descargandoExcel ? (
                  <RefreshCw className="w-4 h-4 animate-spin" />
                ) : (
                  <Download className="w-4 h-4" />
                )}
                {descargandoExcel ? 'Generando...' : 'Descargar Excel'}
              </button>
            </div>
            
            {/* Contenido - Lista de jugadores */}
            <div className="p-4 sm:p-6 overflow-y-auto flex-1 min-h-0">
              {loadingJugadoresSelect ? (
                <div className="text-center py-12">
                  <RefreshCw className="w-12 h-12 animate-spin mx-auto text-gray-400 mb-4" />
                  <p className="text-gray-500">Cargando jugadores...</p>
                </div>
              ) : getJugadoresUnicos().length === 0 ? (
                <div className="text-center text-gray-500 dark:text-gray-400 py-12">
                  <Users className="w-16 h-16 mx-auto mb-4 opacity-50" />
                  <h3 className="text-xl font-semibold mb-2">No hay jugadores</h3>
                  <p>No se encontraron jugadores en este rango de fechas</p>
                </div>
              ) : (
                <div className="bg-white dark:bg-gray-700 rounded-lg shadow overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-gray-100 dark:bg-gray-600 sticky top-0">
                      <tr>
                        <th className="px-3 py-3 text-center w-12"></th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">ID</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Nombre</th>
                        <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Ganancia</th>
                        <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Cuota/Rake</th>
                        <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Total</th>
                        <th className="px-4 py-3 text-center text-xs font-medium text-gray-700 dark:text-gray-300 uppercase">Dias</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                      {getJugadoresUnicos().map((jugador, idx) => {
                        const isChecked = !!jugadoresSeleccionados[jugador.jugador_id];
                        return (
                          <tr 
                            key={jugador.jugador_id} 
                            onClick={() => toggleJugadorSeleccion(jugador.jugador_id)}
                            className={`cursor-pointer transition-colors ${
                              isChecked 
                                ? 'bg-orange-50 dark:bg-orange-900/20 hover:bg-orange-100 dark:hover:bg-orange-900/30' 
                                : 'hover:bg-gray-50 dark:hover:bg-gray-600'
                            }`}
                            data-testid={`jugador-row-${jugador.jugador_id}`}
                          >
                            <td className="px-3 py-3 text-center">
                              {isChecked ? (
                                <CheckSquare className="w-5 h-5 text-orange-600 mx-auto" />
                              ) : (
                                <Square className="w-5 h-5 text-gray-400 mx-auto" />
                              )}
                            </td>
                            <td className="px-4 py-3 text-sm font-mono text-gray-600 dark:text-gray-400">
                              {jugador.jugador_id}
                            </td>
                            <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">
                              {jugador.jugador_name}
                            </td>
                            <td className="px-4 py-3 text-right text-sm">
                              <span className={`font-medium ${jugador.ganancia < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                {formatNumber(jugador.ganancia)}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                              {formatNumber(jugador.cuota_rake)}
                            </td>
                            <td className="px-4 py-3 text-right text-sm">
                              <span className={`font-bold ${jugador.total < 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}>
                                {formatNumber(jugador.total)}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-gray-500 dark:text-gray-400">
                              {jugador.dias}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    {/* Totales solo de seleccionados */}
                    <tfoot className="bg-orange-100 dark:bg-orange-900/30 font-bold sticky bottom-0">
                      <tr>
                        <td className="px-3 py-3"></td>
                        <td colSpan="2" className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                          TOTALES SELECCIONADOS ({Object.keys(jugadoresSeleccionados).length})
                        </td>
                        <td className="px-4 py-3 text-right text-sm">
                          {(() => {
                            const sel = getJugadoresUnicos().filter(j => jugadoresSeleccionados[j.jugador_id]);
                            const total = sel.reduce((s, j) => s + j.ganancia, 0);
                            return (
                              <span className={total < 0 ? 'text-red-600' : 'text-green-600'}>
                                {formatNumber(total)}
                              </span>
                            );
                          })()}
                        </td>
                        <td className="px-4 py-3 text-right text-sm text-gray-900 dark:text-white">
                          {formatNumber(getJugadoresUnicos().filter(j => jugadoresSeleccionados[j.jugador_id]).reduce((s, j) => s + j.cuota_rake, 0))}
                        </td>
                        <td className="px-4 py-3 text-right text-sm">
                          {(() => {
                            const sel = getJugadoresUnicos().filter(j => jugadoresSeleccionados[j.jugador_id]);
                            const total = sel.reduce((s, j) => s + j.total, 0);
                            return (
                              <span className={total < 0 ? 'text-red-600' : 'text-green-600'}>
                                {formatNumber(total)}
                              </span>
                            );
                          })()}
                        </td>
                        <td className="px-4 py-3"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
            
            {/* Footer con info del Excel */}
            <div className="px-6 py-3 bg-gray-50 dark:bg-gray-700 border-t border-gray-200 dark:border-gray-600">
              <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
                El Excel incluye 3 pestanas: <strong>Resumen</strong> (detalle diario), <strong>Totales</strong> (agrupado por jugador) y <strong>Rakeback</strong> (con formulas editables para modificar el %)
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ========== MODAL TOP 5 JUGADORES ========== */}
      {showTop5Modal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[90] flex items-center justify-center p-4" data-testid="top5-modal">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-5xl max-h-[92vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="bg-slate-800 dark:bg-slate-900 px-6 py-5 text-white flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Trophy className="w-7 h-7" />
                <div>
                  <h2 className="text-xl font-bold">Top 5 Jugadores</h2>
                  <p className="text-sm text-white/90">
                    {selectedAgencia?.agencia_name} · UNION 2006
                    {top5Data?.total_jugadores != null && (
                      <span className="ml-2 text-white/75">· {top5Data.total_jugadores} jugadores en el rango</span>
                    )}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowTop5Modal(false)}
                className="text-white/80 hover:text-white p-2 rounded-lg hover:bg-white/10 transition"
                data-testid="btn-top5-close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Controles: rango + tipo */}
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 space-y-3">
              {/* Rango */}
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wide mr-1">Rango:</span>
                <button
                  onClick={aplicarRangoEstaSemana}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition ${top5RangoMode === 'semana' ? 'bg-indigo-600 text-white shadow' : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600'}`}
                  data-testid="top5-rango-semana"
                >
                  📅 Esta semana
                </button>
                <div className={`flex items-center gap-2 px-3 py-1 rounded-lg ${top5RangoMode === 'manual' ? 'bg-indigo-100 dark:bg-indigo-900/40 border border-indigo-300 dark:border-indigo-700' : 'bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600'}`}>
                  <input
                    type="date"
                    value={top5FechaDesde}
                    onChange={(e) => setTop5FechaDesde(e.target.value)}
                    className="bg-transparent text-sm text-gray-700 dark:text-gray-100 focus:outline-none"
                    data-testid="top5-fecha-desde"
                  />
                  <span className="text-gray-400">→</span>
                  <input
                    type="date"
                    value={top5FechaHasta}
                    onChange={(e) => setTop5FechaHasta(e.target.value)}
                    className="bg-transparent text-sm text-gray-700 dark:text-gray-100 focus:outline-none"
                    data-testid="top5-fecha-hasta"
                  />
                  <button
                    onClick={aplicarRangoManual}
                    className="ml-1 px-2 py-0.5 bg-indigo-600 hover:bg-indigo-700 text-white text-xs rounded transition"
                    data-testid="top5-aplicar-manual"
                  >
                    Aplicar
                  </button>
                </div>
              </div>

              {/* Tipo */}
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wide mr-1">Tipo:</span>
                {['PPSR', 'PPST', 'AMBOS'].map((t) => (
                  <button
                    key={t}
                    onClick={() => cambiarTipoTop5(t)}
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition ${top5Tipo === t ? 'bg-emerald-600 text-white shadow' : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600'}`}
                    data-testid={`top5-tipo-${t.toLowerCase()}`}
                  >
                    {t === 'PPSR' ? '🎲 PPSR (Cash)' : t === 'PPST' ? '🃏 PPST (MTT)' : '🔄 AMBOS'}
                  </button>
                ))}
              </div>
            </div>

            {/* Tabs */}
            <div className="flex border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-2 pt-2 overflow-x-auto">
              {[
                { id: 'ganadores',  label: 'Ganadores',  icon: <Trophy className="w-4 h-4" />,    color: 'emerald', show: true },
                { id: 'perdedores', label: 'Perdedores', icon: <Skull className="w-4 h-4" />,    color: 'rose',    show: true },
                { id: 'mesas',      label: 'Más Mesas',  icon: <Dice5 className="w-4 h-4" />,    color: 'sky',     show: top5Tipo !== 'PPST' },
                { id: 'mtt',        label: 'Más MTT',    icon: <Award className="w-4 h-4" />,    color: 'violet',  show: top5Tipo !== 'PPSR' },
              ].filter(t => t.show).map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setTop5Tab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-3 text-sm font-semibold border-b-2 transition whitespace-nowrap ${top5Tab === tab.id ? `border-${tab.color}-500 text-${tab.color}-600 dark:text-${tab.color}-400` : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'}`}
                  data-testid={`top5-tab-${tab.id}`}
                >
                  {tab.icon}
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Contenido */}
            <div className="flex-1 overflow-y-auto p-6">
              {top5Loading ? (
                <div className="flex flex-col items-center justify-center py-16">
                  <Loader2 className="w-10 h-10 text-amber-500 animate-spin mb-3" />
                  <p className="text-gray-500 dark:text-gray-400 text-sm">Cargando rankings...</p>
                </div>
              ) : !top5Data ? (
                <div className="text-center py-16 text-gray-400">Sin datos</div>
              ) : (
                <>
                  {top5Tab === 'ganadores' && (
                    <Top5Table
                      titulo="🏆 TOP 5 GANADORES"
                      filas={top5Data.top_ganadores}
                      columnas={['ID', 'Jugador', 'Ganancia', 'Cuota/Rake', 'Total']}
                      campos={['jugador_id', 'nombre', 'ganancia', 'cuota', 'total']}
                      coloresGanancia="green"
                      formatNumber={formatNumber}
                    />
                  )}
                  {top5Tab === 'perdedores' && (
                    <Top5Table
                      titulo="💀 TOP 5 PERDEDORES"
                      filas={top5Data.top_perdedores}
                      columnas={['ID', 'Jugador', 'Ganancia', 'Cuota/Rake', 'Total']}
                      campos={['jugador_id', 'nombre', 'ganancia', 'cuota', 'total']}
                      coloresGanancia="red"
                      formatNumber={formatNumber}
                    />
                  )}
                  {top5Tab === 'mesas' && (
                    <Top5Table
                      titulo="🎲 TOP 5 MÁS MESAS JUGADAS (PPSR)"
                      filas={top5Data.top_mas_mesas}
                      columnas={['ID', 'Jugador', 'Mesas distintas', 'Manos jugadas']}
                      campos={['jugador_id', 'nombre', 'mesas_jugadas', 'manos_jugadas']}
                      tipoNumero="int"
                      formatNumber={formatNumber}
                    />
                  )}
                  {top5Tab === 'mtt' && (
                    <Top5Table
                      titulo="🃏 TOP 5 MÁS MTT JUGADOS (PPST)"
                      filas={top5Data.top_mas_mtt}
                      columnas={['ID', 'Jugador', 'MTTs jugados', 'Buy-in total']}
                      campos={['jugador_id', 'nombre', 'mtts_jugados', 'buy_in_total']}
                      tipoNumero="mixto"
                      formatNumber={formatNumber}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Subcomponente: Tabla generica de Top 5
function Top5Table({ titulo, filas, columnas, campos, coloresGanancia, tipoNumero, formatNumber }) {
  if (!filas || filas.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400 text-sm">Sin datos para este ranking en el rango seleccionado.</p>
      </div>
    );
  }
  const getValorClass = (campo, val) => {
    if (coloresGanancia === 'green' && (campo === 'ganancia' || campo === 'total')) {
      return val >= 0 ? 'text-emerald-600 dark:text-emerald-400 font-semibold' : 'text-rose-600 dark:text-rose-400 font-semibold';
    }
    if (coloresGanancia === 'red' && (campo === 'ganancia' || campo === 'total')) {
      return 'text-rose-600 dark:text-rose-400 font-semibold';
    }
    return 'text-gray-700 dark:text-gray-200 font-medium';
  };
  const formatear = (campo, val) => {
    if (val == null) return '-';
    if (campo === 'jugador_id' || campo === 'nombre') return String(val);
    if (tipoNumero === 'int' && (campo === 'mesas_jugadas' || campo === 'manos_jugadas' || campo === 'mtts_jugados')) {
      return Number(val).toLocaleString('es-AR');
    }
    if (tipoNumero === 'mixto' && campo === 'mtts_jugados') {
      return Number(val).toLocaleString('es-AR');
    }
    return formatNumber(Number(val));
  };
  return (
    <div>
      <h3 className="text-lg font-bold mb-3 text-gray-800 dark:text-gray-100">{titulo}</h3>
      <div className="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 dark:bg-gray-900/60">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-bold uppercase text-gray-500 dark:text-gray-400 w-12">#</th>
              {columnas.map((c, i) => (
                <th key={c} className={`px-3 py-2 text-xs font-bold uppercase text-gray-500 dark:text-gray-400 ${i >= 2 ? 'text-right' : 'text-left'}`}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
            {filas.map((fila, idx) => (
              <tr key={idx} className="hover:bg-gray-50 dark:hover:bg-gray-900/30 transition">
                <td className="px-3 py-2 text-gray-400 font-bold">{idx + 1}</td>
                {campos.map((campo, i) => (
                  <td key={campo} className={`px-3 py-2 ${i >= 2 ? 'text-right tabular-nums' : 'text-left'} ${getValorClass(campo, fila[campo])}`}>
                    {formatear(campo, fila[campo])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
